const sa = {
	"401": {
		"oops": "عذراً!",
		"noAuth": "لا تملك صلاحية الوصول",
		"goback": "السابق",
		"gohome": "الرئيسية"
	},
	"404": {
		"notFound": "الصفحة غير موجودة"
	},
	"version": {
		"to_old": "الإصدار القديم",
		"to_new": "الإصدار الجديد",
		"default_node": "العقدة الافتراضية",
		"default_theme": "السمة الافتراضية",
		"custom_theme": "سمة مخصصة"
	},
	"intro": {
		"sys_msg": "رسالة النظام",
		"gaa_msg": "إشعار التنبيه",
		"new_guide": "دليل المستخدم الجديد",
		"slider_quite": "خروج",
		"slider_pre": "السابق",
		"slider_next": "التالي",
		"slider_enter": "دخول النسخة الجديدة",
		"step_project_1": "إدارة الأجهزة",
		"step_project_2": "إضافة",
		"step_project_3": "إدارة المشاريع",
		"step_project_4": "إدارة الأجهزة حسب المشاريع",
		"step_project_5": "إنشاء، تعديل، حذف",
		"step_mode_1": "اختر عرض قائمة الأجهزة",
		"step_mode_2": "عرض القائمة عبر",
		"step_mode_3": "قائمة أو بطاقات",
		"step_mode_4": "للعرض",
		"step_device_1": "البحث السريع عن الأجهزة",
		"step_device_2": "إضافة",
		"step_device_3": "متابعة الجهاز",
		"step_device_4": "الميزة",
		"step_device_5": "مرر الماوس",
		"step_device_6": "انقر للمتابعة",
		"step_device_7": "بعد المتابعة",
		"step_device_8": "الجهاز كـ",
		"step_device_9": "تثبيت",
		"step_device_10": "للسهولة في البحث",
		"step_operate_1": "تخطيط أوضح لمعلومات الجهاز",
		"step_operate_2": "عرض مخطط الطاقة، معلومات الجهاز، الرسوم البيانية، التحليل، التفاصيل، الإنذارات"
	},
	"plantCode": {
		"codeApplication": "طلب رمز التجربة",
		"haveDevice": "إذا كان لديك جهاز، سجل ثم سجل الدخول",
		"goRegister": "اذهب للتسجيل",
		"useDemo": "لا توجد دعوة؟ الدعوة للعرض التوضيحي فقط",
		"applyNow": "قدم الآن",
		"code_is_required": "رمز التجربة مطلوب",
		"pleaseCode": "أدخل رمز الدعوة",
		"pleaseName": "أدخل اسمك",
		"PleaseCompanyName": "أدخل اسم الشركة",
		"PleaseCompanyAddress": "أدخل عنوان الشركة",
		"PleaseNumber": "أدخل رقم الهاتف",
		"PleaseEmail": "أدخل بريدك الإلكتروني",
		"PleaseApplication": "أدخل سبب الطلب",
		"reasonNotEmpty": "السبب مطلوب",
		"successfulApplication": "تم التقديم بنجاح، تابع هاتفك أو بريدك"
	},
	"retrieveUser": {
		"forgetUser": "نسيت الحساب",
		"illustrate": "أدخل PN لأي جهاز تحت حسابك للحصول على تلميح الحساب",
		"pn": "أدخل PN لأي جهاز",
		"comfig": "تأكيد",
		"Return_to_login": "العودة لتسجيل الدخول",
		"accountInfo": "معلومات الحساب",
		"user": "اسم المستخدم هو",
		"phone": "رقم الهاتف المرتبط هو",
		"email": "البريد الإلكتروني المرتبط هو",
		"pleasePn": "أدخل PN الجهاز",
		"pnError": "PN غير صحيح",
		"pnErrorMsg": "لم يتم العثور على مجمع البيانات"
	},
	"login": {
		"login": "تسجيل الدخول",
		"loginSuc": "تم تسجيل الدخول بنجاح",
		"no_account_yet": "ليس لديك حساب؟",
		"remember_pwd": "تذكر كلمة المرور",
		"no_invitation": "لا توجد تجربة؟ تواصل معنا",
		"linkman": "يبانغ يانغغوانغ",
		"signup": "سجل الآن",
		"usr": "اسم المستخدم",
		"pwd": "كلمة المرور",
		"sample_station": "عرض",
		"invitation": "رمز التجربة",
		"invitationLogin": "دخول برمز التجربة",
		"forgotPwd": "نسيت كلمة المرور؟",
		"forgotUser": "نسيت الحساب",
		"usrformat": " تنسيق الحساب (2<=الطول<=32)",
		"pwdformat": " تنسيق كلمة المرور (6<=الطول<=32)",
		"YHLogin": "تسجيل دخول المستخدم",
		"YZcode": "أدخل رمز التحقق",
		"code": "اسحب لأسفل لإكمال اللغز",
		"Swipe_right": "اسحب لليمين",
		"scan_login": "تسجيل بالمسح",
		"open": "فتح",
		"Scancode_login": "امسح لتسجيل الدخول",
		"scanning": "مسح",
		"success": "نجاح",
		"Pleaseconfirm_login": "تأكيد تسجيل الدخول",
		"SmartESS": "SmartESS",
		"pv123": "PV123 ESS",
		"X_Tech": "X-Tech",
		"app_download": "تحميل التطبيق",
		"scan_download": "امسح لتحميل التطبيق",
		"YZcode_format": "خطأ في تنسيق رمز التحقق، أدخل أرقام",
		"no_validitycode": "رمز الدعوة غير صالح",
		"auto_login": "تسجيل تلقائي"
	},
	"signup": {
		"login": "سجل دخولك الآن",
		"code": "رمز تحقق 6 أرقام",
		"pwd": "6-32 حرفًا (أرقام، حروف، شرطة سفلية)، حساس لحالة الأحرف",
		"confirm_password": "أعد إدخال كلمة المرور",
		"phone": "الهاتف",
		"phone_form": "حتى 32 حرف، املأ بدقة لاسترجاع كلمة المرور",
		"pn": "14 أو 18 حرف (أرقام وأحرف فقط)",
		"usr": "2-32 حرف (صيني، أحرف، أرقام، شرطات)",
		"email": "البريد الإلكتروني",
		"email_form": "حتى 64 حرف، املأ بدقة لاسترجاع كلمة المرور",
		"existing_account": "لديك حساب؟",
		"Register_account": "تسجيل حساب",
		"signup": "تسجيل",
		"emailSignup": "تسجيل بالبريد",
		"phoneSignup": "تسجيل بالهاتف",
		"registered": "مسجل",
		"success": "تم التسجيل بنجاح",
		"mobileformat": "خطأ في تنسيق الهاتف (6-32)",
		"mobileformat1": "أدخل رقم هاتف صحيح",
		"emailformat": "أدخل بريداً صحيحاً",
		"usrformat": "تنسيق الحساب غير صحيح، 2-32 حرف (يُسمح فقط باللغة الصينية والأحرف والأرقام والشرطات السفلية)",
		"pwdformat": "تنسيق كلمة المرور غير صحيح، 6-32 حرف (يُسمح فقط بالأرقام والأحرف والشرطات السفلية)",
		"pnformat": "تنسيق PN غير صحيح، 14 أو 18 رقماً (يُسمح فقط بالأرقام والأحرف)",
		"qiang": "قوية",
		"zhong": "متوسطة",
		"di": "ضعيفة",
		"qiangdu": "قوة كلمة المرور:",
		"Byte_1": "تم إدخال",
		"Byte_2": "حرف",
		"usr_pl": "اسم المستخدم",
		"pwd_pl": "كلمة المرور",
		"confirm_pl": "أعد إدخال كلمة المرور",
		"confirm_Pwdpl": "تأكيد كلمة المرور",
		"email_pl": "البريد الإلكتروني",
		"mobile_pl": "رقم الهاتف",
		"code_pl": "رمز التحقق",
		"PN_pl": "رقم PN",
		"too_simple": "كلمة المرور ضعيفة جداً، أعد الإدخال",
		"country_pl": "البلد أو المنطقة"
	},
	"createPlant": {
		"imageLimit": "الصور: jpg, png فقط، حتى 8M",
		"fileExceed": "الملف كبير جداً",
		"uploadSuccess": "تم الرفع بنجاح",
		"basic_settings": "الإعدادات الأساسية",
		"Standard_setting": "الإعدادات القياسية",
		"System_settings": "إعدادات النظام",
		"Solar_settings": "إعدادات الطاقة الشمسية",
		"Grid_settings": "إعدادات الشبكة",
		"Battery_settings": "إعدادات البطارية",
		"Battery_settingsTT": "إعدادات البطارية العامة",
		"Battery_settings1": "مجموعة البطارية 1",
		"Battery_settings2": "مجموعة البطارية 2",
		"Work_settings2": "حالة عمل النظام",
		"Machine_settings2": "تمكين وضع الاستعداد",
		"Clear_settings2": "مسح الأعطال",
		"Control_settings": "إعدادات وحدة التخزين",
		"Load_setting": "إعدادات الحمل",
		"other_settings": "إعدادات أخرى",
		"Basic_setting": "الإعدادات الأساسية",
		"Advanced_setting": "الإعدادات المتقدمة",
		"select_all": "تحديد الكل",
		"pv": "طاقة شمسية",
		"gd": "الشبكة",
		"bt": "البطارية",
		"bc": "الحمل",
		"sy": "النظام",
		"eg": "المولد",
		"hl": "حمل المنزل"
	},
	"Upload": {
		"Upload": "رفع"
	},
	"menu": {
		"home": "الرئيسية",
		"datalogger": "إدارة مجمع البيانات",
		"account": "إدارة الحسابات",
		"device": "إدارة الأجهزة",
		"overview": "نظرة عامة",
		"alarm": "إدارة الإنذارات",
		"setting": "إعدادات النظام",
		"personal": "المعلومات الشخصية",
		"basic": "المعلومات الأساسية",
		"password": "تعديل كلمة المرور",
		"alarmSetting": "إعدادات الإنذار",
		"email": "إعدادات البريد",
		"mobile": "إعدادات الهاتف",
		"recharge": "إعدادات الشحن",
		"pay": "شحن البيانات",
		"record": "سجل الشحن",
		"rate": "إعدادات التعريفة",
		"customize": "إعدادات مخصصة",
		"firmware": "إدارة تحديث البرنامج الثابت",
		"firmwarenew": "إدارة البرامج الثابتة",
		"adaptiveFirmware": "موافق فرم ویئر",
		"intelligenceUpgrade": "سمارٹ اپ گریڈ",
		"intelligenceUpgradeTitle": "کوئی اپ گریڈ پیکج دستیاب نہیں ہے، براہ کرم مینوفیکچرر سے رابطہ کریں",
		"intelligenceUpgradeTitle1": "براہ کرم تصدیق کریں کہ کیا ڈیوائس کو سمارٹ اپ گریڈ کرنا ہے؟",
		"intelligenceUpgradeTitle2": "کوئی مطابقت رکھنے والا اپ گریڈ پیکج نہیں ملا",
		"Total_user": "إجمالي المستخدمين:",
		"myDevice": "أجهزتي",
		"strategy": "استراتيجية التحديث المحلي",
		"cloudsUpgrade": "ترقية سحابية",
		"functionalApplication": "التطبيقات الوظيفية",
		"browseAccount": "إدارة الحسابات الفرعية",
		"log": "سجل مجمع البيانات",
		"actionLog": "سجل العمليات",
		"Manufacturer": "إدارة المصنّع",
		"datalogger_list": "قائمة مجمعات البيانات",
		"manufacturer_account": "حساب المصنّع",
		"manufacturer_code": "رمز المصنّع",
		"protocol_binding": "ربط بروتوكول المجمع",
		"type_code": "رمز نوع المجمع",
		"protocol_change": "تغيير بروتوكول المجمع",
		"AIP_Interface": "واجهة API",
		"protocol_operation": "أداة تشغيل البروتوكول",
		"recharge_management": "إدارة الشحن",
		"device_management": "إدارة الأجهزة",
		"KEY_List": "قائمة المفاتيح",
		"Protocol_instruction": "إدارة تعليمات البروتوكول",
		"Raw_data": "تحليل البيانات الخام",
		"Recharge_remedy": "إصلاح الشحن",
		"device_function": "وظائف إدارة الأجهزة",
		"Password_maintenance": "صيانة كلمة مرور التحكم"
	},
	"header": {
		"plant_owner": "مالك المحطة",
		"personal_infor": "المعلومات الشخصية",
		"change_password": "تعديل كلمة المرور",
		"bind_mobile": "ربط الهاتف",
		"bind_email": "ربط البريد",
		"language": "إعدادات اللغة",
		"log_out": "تسجيل الخروج",
		"skin": "تبديل السمة",
		"shopping_mall": "المتجر",
		"operating_manual": "دليل التشغيل",
		"pleaseSelect": "اختر",
		"pleaseSelect1": "اختر الوقت",
		"pnAndAlias": "PN المجمع / اسم المجمع",
		"pnAndSN": "PN / SN"
	},
	"role": {
		"plantOwnerNew": "مستخدم عادي",
		"plantOwner": "مالك المحطة",
		"manufacturer": "حساب المصنّع",
		"distributor": "الموزع",
		"group": "حساب المجموعة",
		"viewer": "مشاهد المحطة",
		"all": "الكل"
	},
	"statistic": {
		"All": "الكل",
		"regiontotal": "إجمالي المناطق",
		"deviceStatus": "حالة الجهاز",
		"regionPercent": "نسبة المناطق",
		"userActivity": "معدل نشاط المستخدم",
		"dataUpdateTime": "وقت تحديث البيانات",
		"normal": "عادي",
		"offline": "غير متصل",
		"Allstate": "جميع الحالات",
		"warning": "تحذير",
		"fault": "عطل",
		"standby": "استعداد",
		"totalDevice": "جميع الأجهزة",
		"allDevice": "إجمالي الأجهزة",
		"totalRegion": "جميع المناطق",
		"other": "أخرى",
		"allAccount": "جميع المستخدمين",
		"generalAccount": "مستخدم مالك",
		"adminAccount": "مستخدم موزع",
		"active": "نشط",
		"inactive": "غير نشط",
		"pv": "بيانات الطاقة الشمسية",
		"gd": "بيانات الشبكة",
		"sy": "بيانات الجهاز",
		"bt": "بيانات البطارية",
		"bc": "بيانات الحمل"
	},
	"account": {
		"title_pwd": "أدخل كلمة مرور صحيحة",
		"title_pwd1": "أدخل كلمة مرور 6-32 حرف",
		"title_pwd2": "أعد إدخال كلمة المرور الجديدة",
		"title_mobile": "أدخل رقم هاتف 11 رقم",
		"title_edit": "أدخل المعلومات للتعديل",
		"title_info": "أدخل بريداً صحيحاً",
		"title_info1": "أدخل رقم هاتف صحيح",
		"allAccount": "جميع المستخدمين",
		"userAccount": "مستخدم",
		"groupAccount": "مجموعة",
		"uselists": "قائمة إدارة المستخدمين",
		"accountManage": "إدارة الحسابات",
		"groupManage": "إدارة المجموعات",
		"activeStatus": "مستوى النشاط",
		"accountGroup": "مجموعة المستخدم",
		"createAccount": "إنشاء حساب",
		"relatedOwner": "ربط المالك",
		"relatedSuccess": "تم الربط بنجاح",
		"adminRelated": "اختر المدير",
		"role": "نوع المستخدم",
		"role1": "نوع المستخدم:",
		"selectUserType": "اختر نوع المستخدم",
		"generalAccount": "حساب عادي",
		"manageAccount": "حساب مدير",
		"accountName": "اسم المستخدم",
		"accountName1": "اسم المستخدم:",
		"accountName2": "أدخل اسم المستخدم",
		"accountRole": "الدور",
		"nickname": "اللقب",
		"nickname1": "اللقب:",
		"password": "كلمة المرور",
		"password1": "كلمة المرور:",
		"newPwd": "كلمة مرور جديدة",
		"newPwd1": "كلمة المرور الجديدة:",
		"confirmpassword": "تأكيد كلمة المرور",
		"confirmpassword1": "تأكيد كلمة المرور:",
		"createTime": "وقت الإنشاء",
		"accountStatus": "حالة الحساب",
		"dataloggerNum": "عدد المجمعات",
		"deviceNum": "عدد الأجهزة",
		"projectNum": "عدد المشاريع",
		"lastLogin": "آخر تسجيل دخول",
		"editUser": "تعديل المستخدم",
		"editAccount": "تعديل الحساب",
		"group": "مجموعة",
		"group1": "المجموعة:",
		"groupto": "إلى مجموعة",
		"changeGroup": "نقل إلى مجموعة:",
		"chooseGroup": "اختر المجموعة",
		"changeGroupSuc": "تم نقل المجموعة بنجاح",
		"defaultGroup": "المجموعة الافتراضية",
		"enable": "تفعيل",
		"disable": "تعطيل",
		"confirmDisable": "تأكيد تعطيل هذا المستخدم؟",
		"afterDisable": "بعد التعطيل لن يتمكن من تسجيل الدخول",
		"disableSuc": "تم التعطيل بنجاح",
		"confirmEnable": "تأكيد تفعيل هذا المستخدم؟",
		"deleteUser": "حذف الحساب",
		"afterEnable": "بعد التفعيل يمكنه تسجيل الدخول",
		"confirmDelete": "تأكيد الحذف؟",
		"notRecovered": "لا يمكن الاسترداد بعد الحذف...",
		"deleteSuc": "تم الحذف بنجاح",
		"resetPwd": "إعادة تعيين كلمة المرور",
		"allTypeUser": "جميع أنواع المستخدمين",
		"powerStationOwner": "مالك المحطة",
		"powerStationViewer": "مشاهد المحطة",
		"admin": "مدير",
		"riyueyuan_lineSonAdmin": "مدير فرعي للخط",
		"riyueyuan_SonAdmin": "مدير فرعي",
		"nodata": "لا توجد بيانات",
		"reason": "سبب عدم عرض الرسم البياني:",
		"reason1": "لا توجد بيانات للجهاز",
		"reason2": "البروتوكول لا يحتوي على حقول الإنتاج والاستهلاك",
		"reason3": "البروتوكول لا يحتوي على حقول القدرة",
		"createSuc": "تم إنشاء الحساب بنجاح",
		"resetPwdSuc": "تم إعادة تعيين كلمة المرور بنجاح",
		"allGroup": "جميع المجموعات",
		"unclassified": "غير مصنف",
		"cannotRedirect": "هذا الحساب ليس حساب تخزين، لا يمكن الانتقال",
		"newPwdEmpty": "كلمة المرور الجديدة مطلوبة!",
		"accountList": "قائمة الحسابات",
		"mobile": "الهاتف",
		"mobile1": "الهاتف:",
		"email": "البريد",
		"email1": "البريد:",
		"modifiedsuccess": "تم تعديل معلومات المستخدم بنجاح!",
		"enablesuccess": "تم التفعيل بنجاح!",
		"disablesuccess": "تم التعطيل بنجاح!",
		"groupsuccess": "تمت عملية المجموعة بنجاح!",
		"pwdresetsuccess": "تم إعادة تعيين كلمة المرور بنجاح!",
		"Deletesuccessfully": "تم حذف الحساب بنجاح!",
		"plantOwner": "مالك المحطة",
		"distributor": "الموزع",
		"operate": "تشغيل",
		"Edit": "تعديل",
		"Delete": "حذف",
		"binding": "ربط",
		"ascription": "إسناد",
		"ascriptionSuccess": "تم الإسناد بنجاح",
		"ascription_result": "نتيجة الإسناد",
		"cancel": "إلغاء",
		"finish": "إنهاء",
		"confirm": "تأكيد",
		"submit": "إرسال",
		"deletegroupsuccess": "تم الإزالة من المجموعة بنجاح!",
		"deletegroup": "إزالة من المجموعة",
		"currentTotal": "حالياً",
		"projects": "مشروع",
		"searchPro": "بحث في المشاريع",
		"devices": "جهاز",
		"accounts": "مستخدم",
		"placeholder": "بحث باسم المستخدم/رقم الهاتف",
		"placeholder1": "أدخل اسم المستخدم/رقم الهاتف",
		"lastLoginTs": "وقت آخر تسجيل دخول",
		"enterHome": "دخول الصفحة الرئيسية",
		"ownedDevices": "الأجهزة المملوكة",
		"Distribution_collector": "توزيع المجمعات",
		"tooltipContent": "يمكن للمدير توزيع المجمعات على الموزعين الفرعيين عبر رقم الطلب",
		"Distribution_method": "طريقة التوزيع",
		"Batch_allocation": "توزيع دفعي",
		"Individual_allocation": "توزيع فردي",
		"Order_allocation": "توزيع بالطلب",
		"PNNum": "رقم PN",
		"order_number": "رقم الطلب",
		"Allocation_result": "نتيجة التوزيع",
		"Assigned_successfully": "تم التوزيع بنجاح",
		"order_check": "تحقق",
		"Confirm_assignment": "تأكيد التوزيع إلى",
		"IsIt": "؟",
		"limitFormat": "فقط ملفات xlsx و xls",
		"Ple_orderNum": "أدخل رقم الطلب",
		"Ple_orderNum1": "أدخل رقم طلب صحيح",
		"Ple_orderNum2": "هذا الطلب يحتوي على",
		"Ple_orderNum3": "مجمع، تأكيد التوزيع إلى",
		"err_orderNum": "الطلب يحتوي على",
		"err_orderNum1": "مجمع مرتبط، تحقق من المجمعات",
		"dataogger_swith": "إمكانية إضافة مجمعات",
		"dataogger_swithTip": "هل يمكن لهذا الحساب إضافة مجمعات",
		"account_number":"الحساب",
		"Role_authority":"الصلاحيات",
		"authority_Management":"إدارة الصلاحيات",
		"Related_roles":"ربط الأدوار",
		"Ple_role1":"اختر دوراً للربط",
		"Ple_role2":"أدخل اسم/معرف الدور",
		"Add_role":"إضافة دور",
		"Edit_role":"تعديل الدور",
		"Role_id":"معرف الدور",
		"Role_name":"اسم الدور",
		"Ple_role3":"أدخل اسم الدور",
		"Role_des":"وصف الدور",
		"Ple_role4":"أدخل وصف الدور",
		"module":"الوحدة",
		"First_page":"الصفحة",
		"Secondary_page":"الصفحة الثانوية",
		"Function_points":"نقاط الوظيفة",
		"Remove_role":"حذف الدور",
		"Ple_role5":"حدد صلاحيات الحساب",
		"No_permission_prompt":"لا توجد صلاحية، تواصل مع المدير الأعلى",
		"Ple_role6":"اسم الدور موجود، أدخل اسماً جديداً",
		"limit_UserTypeNum":"تجاوز الحد، نوع الحساب موجود",
		"limit_UserTypeDataPermission":"حساب الموزع لا يمكن ربطه بدور لديه صلاحيات بيانات",
		"edit_limit_UserTypeDataPermission":"الدور مرتبط بحساب موزع، لا يمكن تعديل صلاحيات البيانات",
		"dataPermission": "صلاحيات البيانات",
		"functionalPermission": "صلاحيات الوظائف"
	},
	"group": {
		"Create_groups": "إنشاء مجموعة",
		"Edit_groups": "تعديل مجموعة",
		"Groups_list": "قائمة المجموعات",
		"Group_name": "اسم المجموعة",
		"Group_name1": "اسم المجموعة:",
		"userCount": "عدد مستخدمي المجموعة",
		"note": "ملاحظة المجموعة",
		"note1": "ملاحظة المجموعة:",
		"Operate": "تشغيل",
		"Delete": "حذف",
		"cancel": "إلغاء",
		"finish": "إنهاء",
		"confirm": "تأكيد",
		"deletegroup": "حذف المجموعة",
		"deleteConfirm": "تأكيد حذف هذه المجموعة؟",
		"entername": "أدخل اسم المجموعة",
		"deletesuc": "تم حذف المجموعة بنجاح",
		"creatsuc": "تم إنشاء المجموعة بنجاح",
		"editsuc": "تم تعديل المجموعة بنجاح"
	},
	"device": {
		"set": "إعدادات",
		"ownerShip": "تغيير المالك",
    "oldOwner": "المالك السابق:",
    "nweOwner": "المالك الجديد:",
    "loading": "جاري التحميل...",
    "moreLoading": "مرر لتحميل المزيد",
		"pleaseDate": "اختر التاريخ",
		"noDate": "لا يمكن اختيار تاريخ مستقبلي",
		"deviceDebug": "تصحيح الجهاز",
		"upgradeType": "نوع الترقية:",
		"defaultUpgrade": "ترقية افتراضية",
		"cloudUpgrade": "ترقية سحابية",
		"continueUpgrade": "متابعة الترقية",
		"continueUpgradeSuccess": "تمت إضافة متابعة الترقية بنجاح",
		"step": "خطوة البدء:",
		"firmware_step_message": "أدخل خطوة البدء",
		"numberRlues": "أدخل رقم خطوة صحيح",
		"firmware_package_message": "اختر البرنامج الثابت",
		"firmware_type_message": "اختر النوع",
		"baudrate_message": "اختر معدل الباود",
		"device_continueUpgrade": "متابعة ترقية الجهاز",
		"read": "قراءة",
		"distribute": "إرسال",
		"optionTitle": "تم التحديد",
		"optionTitle1": "عنصر",
		"optionTitle2": "لا تختار أكثر من 4 معلمات",
		"optionTitle4": "لا تختار أكثر من 12 معلمات",
		"optionTitle3": "لا تختر أكثر من خيارين بوحدات مختلفة",
		"upBatchDeviceTip": "ملاحظة: الترقية الدفعية تُرقّي عدة أجهزة بنفس البرنامج، اختر بحذر!",
		"upSuccessDevice": "الأجهزة التي تمت ترقيتها بنجاح",
		"upFailDevice": "الأجهزة التي فشلت ترقيتها",
		"brandDevice": "الجهاز",
		"brand0": "أنظمة تخزين الطاقة الأخرى ESS",
		"brand1": "عاكس خارج الشبكة",
		"brand2": "عاكس",
		"brand3": "وحدة تخزين متكاملة",
		"Allthemachines": "جميع الأجهزة",
		"deviceList": "قائمة الأجهزة",
		"device": "الجهاز",
		"datalogger": "مجمع البيانات",
		"dataloggerList": "قائمة المجمعات",
		"followList": "الأجهزة المتابعة",
		"proList": "قائمة المشاريع",
		"pro": "المشروع",
		"deviceName": "اسم الجهاز",
		"dataview": "المعلمات الآنية",
		"dataTips": "الجهاز غير متصل، لا توجد بيانات آنية.",
		"overview": "نظرة عامة إحصائية",
		"chart": "الرسوم البيانية",
		"analysis": "تحليل المعلمات",
		"clause": "تفاصيل البيانات",
		"Current_data": "البيانات الحالية",
		"chosenParam": "المعلمات المختارة",
		"optionalParam": "المعلمات الاختيارية",
		"reset": "إعادة تعيين",
		"energyFlow": "مخطط تدفق الطاقة",
		"device_name": "اسم الجهاز",
		"device_pn": "رقم PN",
		"device_sn": "SN الجهاز",
		"device_status": "حالة الجهاز",
		"device_upgrade1": "آخر سجل ترقية",
		"device_upgradeFirmware": "اختر حزمة برامج للترقية",
		"device_upgradeTime": "وقت الترقية",
		"device_upgradeName": "اسم البرنامج",
		"device_upgradeStatus": "حالة الترقية",
		"device_upgradeProgress": "تقدم الترقية",
		"device_type": "نوع الجهاز",
		"device_code": "بروتوكول الاتصال",
		"device_code_form": "بروتوكول الاتصال:",
		"device_model": "طراز الجهاز",
		"User_belong": "المستخدم المالك",
		"field": "التحكم بالحقول",
		"Datalogger_belong": "المجمع المالك",
		"detail": "عرض التفاصيل",
		"pageSize": "عرض في الصفحة",
		"follow": "متابعة",
		"unfollow": "إلغاء المتابعة",
		"report": "التقرير",
		"timeSlot": "الفترة الزمنية",
		"datalogger_pn": "PN المجمع",
		"coll_alias": "اسم المجمع",
		"device_address": "عنوان الجهاز",
		"generation": "الألواح الشمسية",
		"grid": "الشبكة",
		"inverter": "العاکس",
		"battery": "البطارية",
		"consumption": "الحمل",
		"relay": "عاكس صغري",
		"alternator": "المولد",
		"familyLoad": "حمل الأسرة",
		"solar": "الطاقة الشمسية",
		"cur_today": "اليوم",
		"cur_thismonth": "هذا الشهر",
		"cur_thisyear": "هذه السنة",
		"cur_day": "يوم",
		"cur_month": "شهر",
		"cur_year": "سنة",
		"day": "القدرة الآنية",
		"month": "كهربة الشهر",
		"year": "كهربة السنة ",
		"all": "إجمالي الكهربة",
		"pvPower": "قدرة الإنتاج",
		"gridPower": "قدرة الشبكة",
		"batteryPower": "قدرة البطارية",
		"loadPower": "قدرة الحمل",
		"generated": "الإنتاج",
		"charged": "الشحن",
		"discharged": "التفريغ",
		"sold": "البيع",
		"bought": "الشراء",
		"used": "الاستهلاك",
		"normal": "عادي",
		"offline": "غير متصل",
		"warning": "تحذير",
		"fault": "عطل",
		"standby": "استعداد",
		"universal_firmware": "برنامج ثابت عام",
		"communication_firmware": "برنامج الاتصال",
		"control_firmware1": "برنامج التحكم 1",
		"control_firmware2": "برنامج التحكم 2",
		"control_firmware_bms": "برنامج BMS",
		"control_firmware_slavmcu": "برنامج SlavMCU",
		"default": "افتراضي",
		"modifySuc": "تم التعديل بنجاح",
		"instruction_response": "جاري إرسال التعليمة، انتظار الرد...",
		"debug_suc": "تم التصحيح بنجاح",
		"Debugfail": "فشل التصحيح، الجهاز غير متصل",
		"Send_suc": "تم إرسال التعليمة بنجاح",
		"Send_Input": "أدخل قيمة العملية للإرسال",
		"Send_fail": "فشل إرسال التعليمة",
		"fileExceed": "الملف كبير جداً",
		"uploadSuccess": "تم الرفع بنجاح",
		"error1": "فقط ملفات .bin و .hex",
		"file_fist": "اختر البرنامج للترقية أولاً",
		"updatefail": "فشلت الترقية، المجمع قد يكون غير متصل",
		"update_suc": "تمت الترقية بنجاح",
		"deleteSuc": "تم الحذف بنجاح",
		"Operation": "تشغيل",
		"edit": "تعديل",
		"debug": "تصحيح",
		"upgrade": "ترقية دفعية",
		"upgrade1": "ترقية",
		"more": "المزيد",
		"one_click_read": "قراءة بنقرة واحدة",
		"cloudsUpgrade": "ترقية سحابية",
		"queryUpgrade": "استعلام تقدم الترقية",
		"control": "تحكم",
		"delete": "حذف",
		"modify_alias": "تعديل الجهاز",
		"serial_number": "SN الجهاز:",
		"device_alias": "اسم الجهاز:",
		"cancel": "إلغاء",
		"confirm": "تأكيد",
		"Device_sn": "الرقم التسلسلي",
		"Device_pn": "PN الجهاز:",
		"Instruction": "التعليمة:",
		"such_as": "مثال: AA BB CC DD EE FF",
		"return_content": "المحتوى المُعاد:",
		"send": "إرسال التعليمة",
		"clear_data": "مسح البيانات",
		"clear_val": "مسح",
		"copy_val": "نسخ",
		"copy_val_yes": "تم النسخ بنجاح",
		"copy_val_no": "فشل النسخ",
		"Field_Name": "اسم الحقل",
		"Unit": "الوحدة",
		"current_val": "القيمة الحالية",
		"Battery_voltage": "جهد البطارية",
		"Magnification": "المضاعف",
		"Send_Command": "إرسال التعليمة",
		"device_upgrade": "ترقية برنامج الجهاز",
		"device_cloudsUpgrade": "ترقية سحابية للجهاز",
		"select_firmware": "البرنامج:",
		"select_file": "اختر البرنامج",
		"firmware_type": "نوع البرنامج:",
		"select_type": "اختر نوع البرنامج",
		"upgrade_brate": "معدل الباود:",
		"select_brate": "اختر معدل الباود",
		"Upload": "رفع البرنامج",
		"Upload1": "رفع برنامج جديد",
		"confirm_deldte": "تأكيد الحذف؟",
		"deleteDevice": "حذف الجهاز",
		"Today_income": "دخل الإنتاج اليوم",
		"Cumulative_income": "إجمالي دخل الإنتاج",
		"sellProfit_Today": "دخل بيع الكهرباء اليوم",
		"sellProfit_Total": "إجمالي دخل البيع",
		"buyProfit_Today": "مصروف شراء الكهرباء اليوم",
		"buyProfit_Total": "إجمالي مصروف الشراء",
		"noAuth": "لا يوجد مستخدم مالك، لا صلاحية للعرض",
		"statistic": "إحصائيات",
		"protocolStatistic": "إحصائيات البروتوكول",
		"chooseProtocol": "اختر البروتوكول:",
		"parameter": "المعلمة",
		"value": "القيمة",
		"Upgrading": "جاري الترقية، انتظر",
		"System_Failed": "فشل النظام في بدء الترقية بسبب مشاكل اتصال",
		"Device_Offline": "الجهاز أو المجمع غير متصل",
		"In_Upgrading": "الجهاز أو المجمع قيد الترقية",
		"Update_Completed": "تمت الترقية",
		"Voltage": "الجهد",
		"Electric": "التيار",
		"power": "القدرة",
		"frequency": "التردد",
		"Input_form": "جدول الإدخال",
		"add": "إضافة",
		"Output_table": "جدول الإخراج",
		"Please_parameter": "اختر معلمة",
		"Successfully_modified": "تم التعديل بنجاح",
		"edit_control": "تعديل صلاحيات التحكم",
		"Equipment_agreement": "بروتوكول الجهاز",
		"Check_all": "تحديد الكل",
		"Cancel_all": "إلغاء الكل",
		"administrator_cansee": "المحدد: المدير يرى، غير المحدد: لا يرى.",
		"person_cansee": "المحدد: المالك يرى، غير المحدد: لا يرى.",
		"admin_authority": "صلاحيات المدير",
		"person_authority": "صلاحيات المالك",
		"noDataPlease": "لا توجد بيانات، يرجى اختيار فترة أخرى",
		"Sn_deviceName": "SN الجهاز/الاسم/PN/المستخدم",
		"deviceInfo": "معلومات الجهاز",
		"alarmInfo": "معلومات الإنذار",
		"deviceNo": "لم تضف أجهزة بعد",
		"showParam": "عرض المعلمات",
		"selecParameters": "المعلمات المختارة",
		"refresh": "تحديث",
		"obtain": "جلب",
		"moveResults": "نتيجة النقل",
		"moveSuc": "تم النقل بنجاح",
		"maxSelect": "اختر 7 معلمات على الأكثر",
		"minSelect": "اختر معلمة واحدة على الأقل",
		"loadMore": "تحميل المزيد ...",
		"upDevice": "ترقية الجهاز",
		"addUpgrade": "إضافة مهمة ترقية",
		"upgradeProgress": "تقدم الترقية الحالي",
		"deviceUpgradeProgress": "تقدم ترقية الجهاز",
		"addUpgradeSuccess": "تمت الإضافة بنجاح",
		"domain":"النطاق",
		"create_ctrl_title":"إنشاء صيانة التحكم",
		"edit_ctrl_title":"تعديل صيانة التحكم",
		"delete_domain":"حذف النطاق",
		"delete_tips":"تأكيد حذف كلمة مرور التحكم؟",
		"hostname_required":"النطاق مطلوب",
		"device_rerolling":"إعادة تدوير الجهاز",
		"device_synchronization":"مزامنة الجهاز",
		"update_first_data_time":"تعديل وقت البيانات الأول",
		"delete_device_chart_data":"حذف بيانات الرسم البياني",
		"delete_device_data":"حذف تفاصيل البيانات",
		"SN_required":"أدخل رقم SN",
		"device_code1":"رمز الجهاز",
		"devcode_required":"أدخل رمز الجهاز",
		"devaddr_required":"أدخل عنوان الاتصال",
		"devaddr_again":"أعد إدخال عنوان الاتصال",
		"PN":"رمز المجمع",
		"SN":"الرقم التسلسلي",
		"SN_again":"أعد إدخال SN",
		"search_btn":"بحث",
		"tips1":"تلميح: عند المزامنة، إذا الإنتاج غير صحيح، أعد التدوير ثمزامن",
		"tips2":"تلميح: أعد إدخال SN وعنوان الاتصال",
		"tips3":"تلميح: حذف البيانات نهائي، لن يمكن استردادها",
		"tips4_1":"تلميح: منطقة الجهاز الزمنية",
		"tips4_2":"انتبه للمنطقة الزمنية وأدخل الوقت المناسب",
		"delete_tips_1":"تأكيد حذف الطابع الزمني:",
		"delete_tips_2":"لهذه البيانات؟",
		"sn_is_required": "SN مطلوب",
		"sdate_required":"وقت البدء مطلوب",
		"edate_required":"وقت الانتهاء مطلوب",
		"data_tips":"المعلمات غير مكتملة",
		"match_tips":"الإدخال غير متطابق",
				"unbind_tips":"الجهاز غير مرتبط بالمالك، يرجى ربط المالك أولاً"
	},
	"alarm": {
		"device_Warning": "تحذير الجهاز",
		"device_Error": "خطأ الجهاز",
		"device_Fault": "عطل الجهاز",
		"Alarm_Event": "حدث الإنذار",
		"Today_Alarm": "إنذارات اليوم",
		"Alarm_Type": "نوع الإنذار",
		"Device_Type": "نوع الجهاز",
		"Alarm_Status": "حالة المعالجة",
		"Alarm_List": "قائمة الإنذارات",
		"deletes": "حذف",
		"tips": "تلميح",
		"details": "التفاصيل",
		"alarmDetails": "تفاصيل الإنذار",
		"alarmInfo": "حالة الإنذار",
		"alarmDevice": "معلومات الجهاز",
		"delete_alarm": "تأكيد حذف هذا الإنذار؟",
		"Cancel": "إلغاء",
		"Confirm": "تأكيد",
		"Close": "إغلاق",
		"processed": "تمت المعالجة",
		"untreated": "غير معالج",
		"allAlarm": "إجمالي الإنذارات",
		"alarmStatus": "إحصائية حالة الإنذار",
		"warningTitle": "إنذارات آخر 7 أيام",
		"faultTitle": "أعطال آخر 7 أيام",
		"alarmNum": "عدد الإنذارات",
		"faultNum": "عدد الأعطال",
		"all": "الكل",
		"warning": "تحذير",
		"error": "خطأ",
		"fault": "عطل",
		"offline": "غير متصل",
		"inverter": "عاكس",
		"monitor": "جهاز المراقبة",
		"smart_meters": "عداد ذكي",
		"combining_manifolds": "صندوق تجميع",
		"Camera": "كاميرا",
		"Battery": "بطارية",
		"Charger": "شاحن",
		"storage": "وحدة تخزين",
		"Prevent_arcing_island": "جهاز منع الجزيرة",
		"Microinverter": "عاكس صغري",
		"Occurrence_time": "وقت الحدوث",
		"endtime": "وقت الانتهاء",
		"Device_Name": "اسم الجهاز",
		"Device_PN": "PN المجمع",
		"Plant": "المحطة",
		"Alarm_Code": "رمز الإنذار",
		"Alarm_Describe": "وصف الإنذار",
		"Device_SN": "SN الجهاز",
		"device_alias": "اسم الجهاز",
		"device_address": "عنوان الجهاز",
		"User": "المستخدم",
		"Status": "الحالة",
		"Operation": "تشغيل",
		"Delete_selected": "حذف المحدد",
		"deleted_successfully": "تم حذف الإنذار بنجاح!",
		"Alarm_Msg": "رسالة جديدة",
		"Intro_Msg": "دليل المستخدم الجديد",
		"Alarm_Read": "قرأت جميع إشعارات الإنذار",
		"Alarm_data": "لا توجد رسائل جديدة!",
		"Alarm_Message": "جهازك",
		"Alarm_Message1": "يوجد",
		"curSelected": "المحدد حالياً",
		"_Data": "عنصر",
		"more": "المزيد",
		"ruleManage": "إدارة قواعد تصفية الإنذار",
		"ruleNew": "قاعدة جديدة",
		"ruleName": "اسم القاعدة",
		"timeSlot": "الفترة الزمنية",
		"deviceType": "نوع الجهاز",
		"deviceFilter": "تصفية الجهاز",
		"alrmType": "تصفية نوع الإنذار",
		"alrmDes": "تصفية وصف الإنذار",
		"filterHistory": "سجل التصفية",
		"clearHistory": "مسح السجل",
		"view": "عرض",
		"back": "رجوع",
		"exportArchive": "تصدير الإنذار المؤرشف",
		"archiveRecord": "الأرشيف",
		"archiveTip": "تتضمن القائمة جميع الإنذارات غير المعالجة والسجلات المعالجة خلال 7 أيام"
	},
	"datalogger": {
		"activeStatus": "حالة التفعيل",
		"Active": "مفعّل",
		"notActive": "غير مفعّل",
		"timeZone": "المنطقة الزمنية",
		"please_title": "أدخل 'YES' لتأكيد إعادة الضبط",
		"frequency": "معدل الجمع",
		"heartbeat": "نبضة القلب",
		"warehousing_time": "وقت الإدخال",
		"start_address": "عنوان بدء الاستطلاع",
		"deadline_address": "عنوان نهاية الاستطلاع",
		"title_usr": "المجمع بدون مستخدم",
		"datalogger_log": "السجل",
		"min_addr": "أصغر عنوان",
		"max_addr": "أكبر عنوان",
		"transmission": "معرف النقل الشفاف",
		"transparent_set": "مجموعة بروتوكولات النقل الشفاف",
		"devcode": "رمز المصنّع",
		"domain_name": "نطاق الاتصال",
		"transmission1": "وضع الجمع المحلي",
		"transmission2": "وضع النقل الشفاف",
		"noDate": "اختر تاريخاً خلال 3 أيام",
		"paramSetting": "إعدادات المعلمات",
		"paramName": "اسم المعلمة",
		"paramPar": "رقم المعلمة",
		"paramVal": "قيمة المعلمة",
		"dataloggerView": "تفاصيل المجمع",
		"describe": "الوصف",
		"field_name": "اسم الحقل",
		"checkVal": "القيمة",
		"resetTitle1": "هل تريد إعادة تعيين جهاز جمع البيانات؟ (1: السماح بإعادة التسجيل، 2: مسح الأجهزة المرتبطة، 3: حذف جميع البيانات)",
		"unbingTitle": "هل تريد إلغاء ربط جهاز جمع البيانات؟ (1: إزالة مسؤول الموزع المرتبط؛ 2: إعادة الربط تتطلب إضافته من قبل الموزع)",
		"getTitle": "جلب المعلمات",
		"postTitle": "ضبط المعلمات",
		"debugeTitle": "ضبط التصحيح",
		"getName": "جلب المعلمات (عشري)",
		"postName": "رقم المعلمة (عشري)",
		"debugeName": "الأمر:",
		"getVal": "القيمة الحالية:",
		"postVal": "قيمة الضبط:",
		"debugeVal": "النتيجة:",
		"debugeAddr": "عنوان الجهاز:",
		"getSucc": "تم الجلب بنجاح",
		"postSucc": "تم الضبط بنجاح",
		"debugeSucc": "تم الإرسال بنجاح",
		"copyVal": "نسخ القيمة",
		"huoqu": "جلب",
		"shezhi": "ضبط",
		"xiafa": "إرسال التعليمة",
		"copy": "تم النسخ بنجاح",
		"flowCard": "لم يتم العثور على بطاقة صالحة",
		"province": "المحافظة",
		"city": "المدينة",
		"county": "المنطقة",
		"country": "الدولة",
		"Flowcard_status": "حالة بطاقة البيانات",
		"GPRS_traffic": "بيانات GPRS",
		"upBatchDataloggerTip": "ملاحظة: الترقية الدفعية لمجمعات متعددة، اختر بحذر!",
		"upSuccessDatalogger": "المجمعات التي تمت ترقيتها بنجاح",
		"upFailDatalogger": "المجمعات التي فشلت ترقيتها",
		"Datalogger_Status": "حالة المجمع",
		"com_method": "طريقة الاتصال",
		"Datalogger_PN": "PN المجمع",
		"Datalogger_List": "قائمة المجمعات",
		"Datalogger_Name": "اسم المجمع",
		"Ple_PN": "أدخل PN المجمع",
		"Ple_Alias": "أدخل اسم المجمع",
		"Datalogger_type": "نوع المجمع",
		"Datalogger_model": "الطراز",
		"Datalogger_method": "طريقة الاتصال",
		"Status": "الحالة",
		"usr_belong": "المستخدم المالك",
		"administrator": "المدير المالك",
		"Communication_balance": "رصيد الاتصالات",
		"load": "عدد الأجهزة",
		"Firmware_Version": "إصدار البرنامج",
		"signal": "الإشارة",
		"Operation": "تشغيل",
		"edit": "تعديل",
		"reboot": "إعادة التشغيل",
		"unbind": "فك الربط",
		"more": "المزيد",
		"resetData": "إعادة ضبط البيانات",
		"unbindUsr": "فك ربط المالك",
		"debug": "تصحيح",
		"upgrade": "ترقية",
		"delete": "حذف",
		"deleteTitle": "حذف المجمع",
		"reset": "إعادة ضبط",
		"resetCode": "أدخل YES للتأكيد",
		"modify_datalog": "تعديل معلومات المجمع",
		"cancel": "إلغاء",
		"confirm": "تأكيد",
		"datalogger_debug": "تصحيح المجمع",
		"communication_address": "عنوان الاتصال:",
		"Instruction": "التعليمة:",
		"such_as": "مثال: AA BB CC DD EE FF",
		"return_content": "المحتوى المُعاد:",
		"send": "إرسال التعليمة",
		"check": "جانچ",
		"InstructionType": "ہدایات کا فارمیٹ",
		"endMarker": "اختتامی نشان",
		"noMarker": "کوئی اختتامی نشان نہیں",
		"noCheck": "کوئی جانچ نہیں",
		"InstructionIssue": "ہدایات جاری کرنا",
		"Insufficient": "تعداد ناکافی",
		"clear_data": "مسح البيانات",
		"device_upgrade": "ترقية البرنامج",
		"select_firmware": "البرنامج:",
		"select_file": "اختر البرنامج",
		"Upload": "رفع البرنامج",
		"prompt_message": "رسالة تلميح",
		"confirm_deldte": "بعد الحذف لن تتمكن من إدارة البيانات",
		"Normal": "عادي",
		"Offline": "غير متصل",
		"Online": "متصل",
		"Normal1": "حالة الاتصال",
		"Offline1": "حالة عدم الاتصال",
		"Allstate": "جميع الحالات",
		"modifySuc": "تم التعديل بنجاح",
		"resetSuc": "تمت إعادة الضبط بنجاح",
		"unbindSuc": "تم فك الربط بنجاح",
		"devaddrfail": "عنوان الاتصال مطلوب",
		"Debugfail": "فشل التصحيح، المجمع غير متصل",
		"instruction_response": "جاري إرسال التعليمة، انتظار الرد...",
		"fileExceed": "الملف كبير جداً",
		"uploadSuccess": "تم الرفع بنجاح",
		"error1": "فقط ملفات .bin و .hex",
		"file_fist": "اختر البرنامج للترقية أولاً",
		"updatefail": "فشلت الترقية، المجمع قد يكون غير متصل",
		"update_suc": "تمت الترقية بنجاح",
		"deleteSuc": "تم الحذف بنجاح",
		"debug_suc": "تم التصحيح بنجاح",
		"create": "إنشاء",
		"addSuc": "تمت إضافة المجمع بنجاح",
		"add": "إضافة جهاز",
		"addScq": "إضافة مجمع",
		"batchAddScq": "إضافة مجمعات دفعياً",
		"editDatalogger": "تعديل المجمع",
		"editDataloggerName": "تعديل المجمع",
		"resetDataloggerName": "إعادة ضبط المجمع",
		"unbindDataloggerName": "فك ربط المجمع",
		"resetDataloggerExplain": "إعادة الضبط تمسح جميع البيانات، لا يمكن استردادها!",
		"unbindDataloggerExplain": "فك الربط يزيل العلاقة مع المالك، أعد الربط يدوياً.",
		"rebootDataloggerName": "إعادة تشغيل المجمع",
		"rebootDataloggerSuc": "تمت إعادة تشغيل المجمع بنجاح",
		"fixOnRebootDataloggerName": "تأكيد إعادة تشغيل المجمع:",
		"fixOnRebootDataloggerName1": "؟",
		"unbindTitle": "أدخل \"YES\" لتأكيد فك ربط المجمع.",
		"resetTitle": "أدخل \"YES\" لتأكيد إعادة ضبط المجمع.",
		"editSuc": "تم تعديل المجمع بنجاح",
		"basic_info": "المعلومات الأساسية",
		"datalogger_pn": "PN المجمع:",
		"datalogger_name": "اسم المجمع:",
		"nominalPower": "القدرة الاسمية",
		"install_date": "تاريخ التركيب",
		"installer": "المركّب",
		"location_info": "معلومات الموقع",
		"location_info1": "المعلومات الجغرافية",
		"district": "المنطقة الإدارية",
		"address": "موقع المجمع",
		"dataloggerAddress": "العنوان التفصيلي",
		"enterPosition": "أدخل موقع المجمع",
		"longi_lati": "خطوط الطول والعرض",
		"latitude": "خط العرض",
		"longitude": "خط الطول",
		"currentAddress": "العنوان الحالي:",
		"timezone": "المنطقة الزمنية",
		"timezone1": "المنطقة الزمنية",
		"cp1": "اختر تاريخ التركيب",
		"cp2": "اختر المنطقة الزمنية",
		"cp3": "أدخل القدرة الاسمية",
		"cp4": "اختر عملة الدخل",
		"cp5": "أدخل اسم الجهاز",
		"cp6": "اختر المشروع",
		"cp7": "اختر خطوط الطول والعرض",
		"lonRange": "خط الطول من -180 إلى 180",
		"latRange": "خط العرض من -90 إلى 90",
		"cp9": "أدخل العنوان الحالي",
		"cp10": "أدخل اسم المشروع",
		"income_info": "معلومات الدخل",
		"currency": "عملة الدخل:",
		"buyProfit": "سعر الشراء:",
		"sellProfit": "سعر البيع:",
		"unitProfit": "سعر الاستهلاك:",
		"generateProfit": "سعر الإنتاج:",
		"noNegative": "أدخل رقماً غير سالب",
		"buyProfitNew": "سعر الشراء",
		"sellProfitNew": "سعر البيع",
		"generateProfitNew": "سعر الإنتاج",
		"add_datalogger": "إضافة مجمع جديد",
		"add_suc": "تمت الإضافة بنجاح",
		"basicInfo": "المعلومات الأساسية",
		"connectionInfo": "معلومات الاتصال",
		"finishAdding": "إنهاء الإضافة",
		"addResults": "نتيجة الإضافة",
		"addedSuccessfully": "تمت الإضافة بنجاح",
		"finish": "إنهاء",
		"continueAdding": "متابعة الإضافة",
		"nowNoAdd": "تأجيل الإضافة",
		"reAdd": "إعادة الإضافة",
		"editResults": "نتيجة التعديل",
		"resetResults": "نتيجة إعادة الضبط",
		"unbindResults": "نتيجة فك الربط",
		"delResults": "نتيجة الحذف",
		"locationTip": "تلميح: أدخل الموقع يدوياً إذا كان غير دقيق",
		"upDatalogger": "ترقية المجمع",
		"type_code": "رمز نوع المجمع",
		"type_name": "اسم نوع المجمع",
		"new_type": "إضافة نوع مجمع جديد",
		"modification_type": "تعديل نوع المجمع",
		"delete_type": "حذف رمز نوع المجمع",
		"prompt": "تحضير حذف رمز نوع المجمع",
		"prompt_codetip": "رمز نوع المجمع مطلوب",
		"prompt_desctip": "اسم نوع المجمع مطلوب",
		"input_prompt": "رمز نوع المجمع حرف واحد",
		"success_prompt": "تمت إضافة الرمز بنجاح!",
		"multi_binding": "ربط دفعي",
		"search_PN": "أدخل رقم PN",
		"empty_prompt": "لا توجد بيانات، تحقق من PN",
		"bingding_status": "حالة الربط",
		"unbound": "غير مرتبط",
		"bound": "مرتبط",
		"protocol_code": "رمز البروتوكول",
		"protocol_name": "اسم البروتوكول",
		"bind": "ربط (تعديل)",
		"bind_title": "ربط البروتوكول (تعديل)",
		"batch_bind_title": "ربط دفعي (تعديل)",
		"18digit": "ربط 18 رقم",
		"18digit_title": "ربط بروتوكول 18 رقم",
		"batch_protocol_binding": "ربط بروتوكول دفعي",
		"upload_tips": "تلميح: ملفات xlsx, xls فقط، راجع الصورة",
		"disabledText": "جاري جلب البيانات...",
		"disabledText1": "اختر البروتوكول",
		"upload_err": "فقط ملفات xlsx, xls",
		"bounding_success": "تم ربط البروتوكول بنجاح!",
		"unbounding_success": "تم فك ربط البروتوكول بنجاح!",
		"unbound_tips": "تأكيد فك ربط المجمع",
		"unbound_tips1": "من البروتوكول؟",
		"batch_change": "تغيير دفعي",
		"batch_protocol_change": "تغيير بروتوكول دفعي",
		"dataloggerTipName": "المجمع مُضاف بالفعل، أضافه",
				"batch_edit_datalogger": "تعديل مجمع البيانات دفعة واحدة",
				"upload_column_tips": "تذكير ودي: العمود A هو PN المجمع، العمود B هو عدد التحميل، العمود C هو معدل البود، العمود D هو بروتوكول الاتصال، العمود E هو رمز الشركة المصنعة للجهاز، العمود F هو رمز الشركة المصنعة للبروتوكول، العمود G هو وضع الجمع، العمود H هو الحد الأدنى لعنوان الاتصال، العمود I هو الحد الأقصى لعنوان الاتصال، لا حاجة للعنوان، راجع الصورة التالية",
				"upload_csv_tips": "تذكير ودي: يجب أن يكون تنسيق الملف csv، راجع الصورة التالية لمحتوى الملف",
				"click_enlarge": "انقر للتكبير لعرض التفاصيل",
						"collector_expire_time": "وقت انتهاء صلاحية المجمع",
						"collection_cycle": "دورة الجمع",
								"ascii_display": "عرض ASCII:"
	},
	"map": {
		"sn": "SN الجهاز:",
		"datalogger": "اسم المجمع:",
		"address": "عنوان الجهاز:"
	},
	"rate": {
		"device_status": "حالة الجهاز",
		"datalogger_pn": "PN المجمع",
		"datalogger_pns": "PN المجمع:",
		"rate_list": "قائمة التعريفة",
		"datalogger_name": "اسم المجمع",
		"status": "الحالة",
		"Income_currency": "عملة الدخل",
		"Income_currencys": "عملة الدخل:",
		"generate_Rate": "تعريفة الإنتاج",
		"generate_Rates": "تعريفة الإنتاج:",
		"sell_Rate": "تعريفة البيع",
		"sell_Rates": "تعريفة البيع:",
		"buy_Rate": "تعريفة الشراء",
		"buy_Rates": "تعريفة الشراء:",
		"operating": "تشغيل",
		"edit": "تعديل",
		"rate": "التعريفة",
		"cancel": "إلغاء",
		"confirm": "تأكيد",
		"modifySuc": "تم التعديل بنجاح",
		"resetSuc": "تمت إعادة الضبط بنجاح",
		"unbindSuc": "تم فك الربط بنجاح"
	},
	"auxiliary": {
		"auxiliaryFunction": "الوظائف المساعدة",
		"chartSupplement": "الرسم البياني الحقيقي",
		"realChart": "عند التفعيل يعرض البيانات الحقيقية."
	},
	"strategy": {
		"strategyUpgrade": "قائمة استراتيجيات الترقية",
		"to": "رجوع",
		"UpgFirmware": "إدارة البرامج المحلية",
		"strategyIntro": "نظرة عامة على الترقية المحلية",
		"strategyInfor": "معلومات استراتيجية الترقية",
		"strategyIntro1": "ملاحظة: هذه الوحدة للترقية المحلية عبر البلوتوث فقط",
		"stategyStep2": "إضافة حزمة برامج",
		"stategyStep3": "ارفع حزمة البرامج في إدارة البرامج",
		"stategyStep4": "ترقية محلية عبر التطبيق",
		"stategyStep5": "بعد تفعيل الاستراتيجية، التطبيق يرسل تذكيراً",
		"stategyStep6": "إضافة استراتيجية ترقية",
		"stategyStep7": "أضف استراتيجية، اختر البرنامج، اضبط الطريقة والأجهزة",
		"stategyStep8": "عرض سجلات الترقية",
		"stategyStep9": "عرض حالة ونتيجة الترقية",
		"stategyDetail": "اسم الاستراتيجية",
		"stategyDetail1": "برنامج الترقية",
		"stategyDetail2": "حجم الحزمة (KB)",
		"stategyDetail3": "نوع البرنامج",
		"stategyDetail4": "معدل الباود",
		"stategyDetail5": "طريقة الترقية",
		"stategyDetail6": "تقدم الترقية",
		"stategyDetail7": "حالة الاستراتيجية",
		"stategyDetail8": "وقت التفعيل",
		"stategyDetail9": "وقت الانتهاء",
		"upgradeList": "قائمة سجلات الترقية",
		"add_strategy": "قائمة استراتيجيات الترقية",
		"strategy_time": "الوقت الفعال",
		"strategy_code": "رمز الاستراتيجية",
		"strategy_name": "اسم الاستراتيجية",
		"strategy_desc": "وصف الاستراتيجية",
		"strategy_firmware": "برنامج الترقية",
		"strategy_type": "نوع البرنامج",
		"strategy_baudrate": "معدل الباود",
		"uprade_type": "طريقة الترقية",
		"uprade_name": "ترقية إجبارية",
		"uprade_name1": "ترقية اختيارية",
		"uprade_result": "نتيجة الترقية",
		"uprade_success": "نجحت الترقية",
		"uprade_fail": "فشلت الترقية",
		"uprade_status": "حالة الترقية",
		"uprade_time": "وقت الترقية",
		"strategy_number": "عدد أجهزة الترقية",
		"strategy_status": "حالة الاستراتيجية",
		"start_time": "وقت التفعيل",
		"end_time": "وقت الانتهاء",
		"edit": "تعديل",
		"edit_strategy": "تعديل الاستراتيجية",
		"view": "عرض",
		"view_strategy": "عرض الاستراتيجية",
		"cancel": "إلغاء",
		"cancel_strategy": "إلغاء الاستراتيجية",
		"force_upgrade": "ترقية إجبارية",
		"suggested_upgrade": "ترقية اختيارية",
		"In_effect": "سارية",
		"expired": "منتهية",
		"Not_started": "لم تبدأ",
		"Not_upgraded": "لم تُرقَّ",
		"Yes_started": "تمت الترقية",
		"policy_information": "معلومات الاستراتيجية",
		"associated_device": "الأجهزة المرتبطة",
		"completion_strategy": "إنهاء الاستراتيجية",
		"upgrade_strategy_list": "قائمة استراتيجيات الترقية",
		"Next": "التالي",
		"TOP": "السابق",
		"confirm": "تأكيد",
		"go_back": "رجوع",
		"strategy_detail": "تفاصيل الاستراتيجية",
		"strategy_search": "رمز/اسم الاستراتيجية",
		"strategy_upgrade_search": "SN الجهاز/PN المجمع",
		"upgrade_remind": "تذكير الترقية",
		"remind_desc": "وصف التذكير",
		"default_desc": "الوصف الافتراضي",
		"default_desc1": "الجهاز يحتاج ترقية ليعمل، انقر للترقية.",
		"message_name": "أدخل اسم الاستراتيجية",
		"message_desc": "أدخل وصف الاستراتيجية",
		"message_firmware": "اختر البرنامج",
		"message_type": "اختر نوع البرنامج",
		"message_baudrate": "اختر معدل الباود",
		"message_timezone": "اختر المنطقة الزمنية",
		"message_time": "اختر الوقت الفعال",
		"message_uprade_type": "اختر نوع الترقية",
		"delete_firmware": "تأكيد إلغاء هذه الاستراتيجية؟",
		"delete_desc": "بعد الإلغاء لا يمكن الاسترداد",
		"Upgrade_tip": "اختر الأجهزة المرتبطة",
		"Upgrade_result": "تمت الإضافة بنجاح",
		"start_date": "تاريخ التفعيل",
		"End_date": "تاريخ الانتهاء",
		"limits":"تلميح: العمود A يحتوي PN، بلا عنوان",
		"mueas":"استراتيجية الترقية",
		"upNum":"عدد أجهزة الترقية",
		"deletCL":"حذف الاستراتيجية",
		"deletCL_TEST":"تأكيد حذف هذه الاستراتيجية؟",
		"ONE_UP":"ترقية جهاز واحد",
		"MO_UP":"ترقية أجهزة دفعية",
		"MO_text":"تم استيراد",
		"MO_tex1":"مكرر",
		"MO_tex3":"غير موجود",
		"MO_tex2":"جهاز",
		"MO_tex4":"الحزمة مستخدمة في استراتيجية سارية، لا يمكن حذفها"
	},
	"cloudsUpgarde": {
		"cloudsFirmware": "برنامج الترقية السحابية",
		"cloudsFirmwareList": "قائمة الترقية السحابية"
	},
	"upgradeManagement": {
		"create": "إنشاء",
		"cancel": "إلغاء",
		"confirm": "تأكيد",
		"upload_firmware": "رفع البرنامج",
		"edit_firmware": "تعديل البرنامج",
		"download_firmware": "تنزيل البرنامج",
		"delete_desc": "بعد الحذف لا يمكن الاسترداد",
		"eidt_success": "تم التعديل بنجاح",
		"delete_success": "تم الإلغاء بنجاح",
		"delete_success1": "تم الحذف بنجاح",
		"download_success": "جاري التنزيل",
		"firmware_name": "اسم حزمة البرنامج",
		"Firmware_Version": "رقم الإصدار",
		"please_upgrade": "اختر ملفاً للرفع",
		"upgrade_success": "تم رفع البرنامج بنجاح",
		"please_input": "أدخل",
		"Remarks": "وصف البرنامج",
		"Upload": "رفع البرنامج",
		"download_firmware_prompt": "تأكيد تنزيل هذا البرنامج؟",
		"upgrade_file_format": "فقط .bin/.hex، حتى 1MB",
		"upgrade_file_format1": "فقط .bin/.hex",
		"upgrade_file_format2": "الملف حتى 1MB",
		"firmwareName_empty": "اسم البرنامج مطلوب",
		"firmwareVersion_empty": "رقم الإصدار مطلوب",
		"download_exception": "خطأ في التنزيل، حاول لاحقاً",
		"upload_result": "اپ لوڈ کا نتیجہ",
	},
	"project": {
		"choice": "تصفية",
		"move": "نقل",
		"manageProject": "إدارة المشاريع",
		"project": "المشروع",
		"defaultProject": "المشروع الافتراضي",
		"projectName": "اسم المشروع",
		"projectRemark": "وصف المشروع",
		"projectId": "معرف المشروع",
		"createProject": "إنشاء مشروع",
		"createResults": "نتيجة الإنشاء",
		"createSuc": "تم الإنشاء بنجاح",
		"editProject": "تعديل المشروع",
		"editResults": "نتيجة التعديل",
		"editSuc": "تم التعديل بنجاح",
		"delProject": "حذف المشروع",
		"delResults": "نتيجة الحذف",
		"delSuc": "تم الحذف بنجاح",
		"upgradeResults": "نتيجة الترقية",
		"upgradeSuc": "تمت الترقية بنجاح",
		"back": "رجوع",
		"placeholder": "البحث باسم الجهاز/PN/SN",
		"modifySuc": "نجاح",
		"upload": "رفع صورة",
		"limit": "(حتى 1M)",
		"moveTo": "نقل إلى",
		"moveSelect": "نقل المحدد",
		"deviceSn": "SN الجهاز",
		"tipCard": "بطاقات",
		"tipList": "قائمة",
		"tipSearchSN": "بحث بالجهاز",
		"tipSearchPN": "بحث بالمجمع",
		"energyCurrent": "القدرة الحالية",
		"energyDate": "إنتاج اليوم",
		"energyMonth": "إنتاج الشهر",
		"energyYear": "إنتاج السنة",
		"energyTotal": "إجمالي الإنتاج"
	},
	"constant": {
		"renminbi": "يوان صيني (￥)",
		"meiyuan": "دولار أمريكي ($)",
		"ouyuan": "يورو (€)",
		"aoyuan": "دولار أسترالي ($A)",
		"yingbang": "جنيه إسترليني (£)",
		"gangbi": "دولار هونغ كونغ (HK$)",
		"ruidian": "كرونا سويدية (Kr)",
		"lubi": "روبية هندية (₹)",
		"moxige": "بيزو مكسيكي (Mex$)",
		"baxi": "ريال برازيلي (R$)",
		"Pakistani": "روبية باكستانية (Rs)",
		"Rand": "راند جنوب أفريقي (R)",
		"gmt0": "(GMT +00:00) دبلن، إدنبرة، لشبونة، لندن",
		"gmt_1": "(GMT +01:00) باريس، مدريد، كوبنهاغن، روما",
		"gmt_2": "(GMT +02:00) عمان، دمشق، القاهرة، أثينا",
		"gmt_3": "(GMT +03:00) بغداد، الكويت، الرياض، نيروبي",
		"gmt_4": "(GMT +04:00) أبو ظبي، مسقط، يريفان",
		"gmt_5": "(GMT +05:00) إسلام أباد، كراتشي",
		"gmt_55": "(GMT +05:30) نيودلهي",
		"gmt_6": "(GMT +06:00) دكا، أستانا",
		"gmt_65": "(GMT +06:30) ميانمار",
		"gmt_7": "(GMT +07:00) بانكوك، هانوي، جاكرتا",
		"gmt_8": "(GMT +08:00) بكين، تشونغتشينغ، هونغ كونغ، أورومتشي، تايبيه، كوالالمبور، سنغافورة",
		"gmt_9": "(GMT +09:00) أوساكا، طوكيو، سول",
		"gmt_10": "(GMT +10:00) بريسبان، كانبيرا، سيدني",
		"gmt_11": "(GMT +11:00) جزر سليمان",
		"gmt_12": "(GMT +12:00) أوكلاند، فيجي",
		"gmt_13": "(GMT +13:00) نوكوالوفا",
		"gmt_neg_1": "(GMT -01:00) جزر الأزور",
		"gmt_neg_2": "(GMT -02:00) وسط المحيط الأطلسي",
		"gmt_neg_3": "(GMT -03:00) برازيليا، بوينس آيرس",
		"gmt_neg_4": "(GMT -04:00) سانتياغو، لاباز",
		"gmt_neg_5": "(GMT -05:00) التوقيت الشرقي",
		"gmt_neg_6": "(GMT -06:00) التوقيت المركزي",
		"gmt_neg_7": "(GMT -07:00) التوقيت الجبلي",
		"gmt_neg_8": "(GMT -08:00) التوقيت الهادئ",
		"gmt_neg_9": "(GMT -09:00) ألاسكا",
		"gmt_neg_10": "(GMT -10:00) هاواي",
		"gmt_neg_11": "(GMT -11:00) جزر ساموا",
		"gmt_neg_12": "(GMT -12:00) غرب خط التغيير"
	},
	"basic": {
		"modifySuc": "تم التعديل بنجاح!",
		"Personal_info": "تعديل المعلومات",
		"User_name": "اسم المستخدم:",
		"User_name1": "اسم المستخدم",
		"Nickname": "اللقب:",
		"Nickname1": "اللقب",
		"editNickname": "تعديل اللقب",
		"Ple_Nickname": "أدخل اللقب",
		"setNickname": "ضبط اللقب",
		"Email": "البريد:",
		"Email1": "البريد الإلكتروني",
		"Email2": "البريد الإلكتروني:",
		"editEmail": "تغيير البريد",
		"setEmail1": "ربط البريد",
		"Mobile": "رقم الهاتف:",
		"Mobile1": "رقم الهاتف",
		"editMobile": "تغيير رقم الهاتف",
		"setMobile": "ربط رقم الهاتف",
		"Avatar": "صورة المستخدم",
		"basic": "المعلومات الشخصية",
		"Save": "حفظ",
		"Select_all": "استعادة التحديد الكامل",
		"Ple_phone": "أدخل رقم الهاتف للربط",
		"code": "رمز التحقق:",
		"Ple_code": "أدخل رمز التحقق",
		"Obtain_code": "جلب الرمز",
		"Bind_phone": "ربط الهاتف",
		"After_bindingPh": "بعد الربط يمكن استعادة كلمة المرور عبر الهاتف",
		"Untie_phone": "فك ربط الهاتف",
		"Change_phone": "تغيير الهاتف",
		"Bind_email": "ربط البريد",
		"Ple_email": "أدخل البريد للربط",
		"re_enter": "جلب مجدداً",
		"After_bindingEm": "بعد الربط يمكن استعادة كلمة المرور عبر البريد",
		"Unbind_email": "فك ربط البريد",
		"Change_email": "تغيير البريد",
		"unbind_Ph": "تأكيد فك ربط الهاتف؟",
		"unbinding_Ph": "بعد فك الربط لا يمكن استعادة كلمة المرور!",
		"unbind_Em": "تأكيد فك ربط البريد؟",
		"unbinding_Em": "بعد فك الربط لا يمكن استعادة كلمة المرور!",
		"mobile_code": "تم إرسال الرمز لهاتفك، تحقق منه",
		"email_code": "تم إرسال الرمز لبريدك، تحقق منه",
		"suc_ph": "تم ربط الهاتف بنجاح",
		"suc_em": "تم ربط البريد بنجاح",
		"code_frequently": "إرسال متكرر، حاول لاحقاً",
		"personalCenter": "إعدادات الحساب",
		"basicInfo": "المعلومات الأساسية",
		"accountSecurity": "أمان الحساب",
		"backTo": "رجوع",
		"uploadAvatar": "تغيير الصورة",
		"bindPhone": "ربط الهاتف",
		"bindEmail": "ربط البريد",
		"changePwdTip": "كلمة مرور قوية تحمي حسابك. ضبط كلمة 6-32 حرف.",
		"bindPhoneTipBefore": "الهاتف المرتبط:",
		"bindEmailTipBefore": "البريد المرتبط:",
		"bindPhoneTip": "ضبط هاتف لتسجيل الدخول واستعادة كلمة المرور.",
		"bindEmailTip": "ضبط بريد لتسجيل الدخول واستعادة كلمة المرور.",
		"bindPhoneTipAfter": "، لتسجيل الدخول واستعادة كلمة المرور.",
		"changeBtn": "تعديل",
		"changePwd": "تعديل كلمة المرور",
		"changePwdSuc": "تم إعادة تعيين كلمة المرور بنجاح",
		"finished": "إنهاء",
		"retry": "إعادة المحاولة",
		"changeRes": "نتيجة التعديل",
		"bindRes": "نتيجة الربط",
		"noHanzi": "كلمة المرور لا تحتوي صينية",
		"Nickname_length_tip": "طول اللقب 2-32 حرف"
	},
	"password": {
		"User_name": "اسم المستخدم:",
		"Password": "تعديل كلمة المرور",
		"Current_password": "كلمة المرور القديمة:",
		"New_password": "كلمة المرور الجديدة:",
		"Config_newpassword": "تأكيد كلمة المرور الجديدة:",
		"PLCurrent_password": "أدخل كلمة المرور القديمة",
		"PLNew_password": "أدخل كلمة المرور الجديدة",
		"PLConfig_newpassword": "أكد كلمة المرور الجديدة",
		"editPwdSuc": "تم تعديل كلمة المرور بنجاح!",
		"loginAgain": "تم التعديل، سجل الدخول مجدداً",
		"Save": "حفظ"
	},
	"settingalarm": {
		"chosesstation": "اختر المحطة",
		"addEmails": "إضافة بريد",
		"delete": "تم حذف البريد بنجاح",
		"deletes": "حذف",
		"Email_List": "قائمة البريد",
		"Add_Mailbox": "إضافة دفع بريدي",
		"cancel": "إلغاء",
		"Add": "إضافة",
		"Email_Setting": "إعدادات الدفع البريدي",
		"Alarm_Type": "نوع الإنذار:",
		"Warning": "تحذير",
		"Error": "خطأ",
		"Fault": "عطل",
		"Receiving_Report": "إدارة التقارير",
		"Daily_Report": "تقرير يومي",
		"Monthly_Report": "تقرير شهري",
		"Yearly_Report": "تقرير سنوي",
		"Receiving_Plant": "المحطات المدفوعة:",
		"E_Mail": "البريد:",
		"Email": "البريد",
		"Plant": "المحطة المرتبطة",
		"Operation": "تشغيل",
		"Alarm_Typetabel": "نوع الإنذار",
		"Yes": "نعم",
		"No": "لا",
		"Delete": "حذف",
		"suredelete": "تأكيد حذف هذا الدفع البريدي؟",
		"Delete_Mailbox": "حذف البريد",
		"Add_suc": "تمت إضافة البريد بنجاح!",
		"create": "إنشاء",
		"list": "الرقم",
		"edit": "تعديل"
	},
	"recharge": {
		"Datalogger_List": "قائمة المجمعات",
		"Datalogger_PN": "PN المجمع",
		"DataloggerPN": "PN:",
		"DataloggerName": "الاسم",
		"CCID": "رقم البطاقة",
		"CCID_time": "تاريخ انتهاء البطاقة",
		"Plant": "اسم المحطة",
		"Connecting_Devices": "عدد الأجهزة",
		"Status": "حالة البطاقة",
		"Signal": "قوة الإشارة",
		"Activation_Time": "وقت التفعيل",
		"Dead_Time": "وقت الانتهاء",
		"Operation": "تشغيل",
		"Recharge_record": "سجل الشحن",
		"Time": "وقت الشحن",
		"Order_Number": "رقم الطلب",
		"Rcharge_Month": "أشهر الشحن",
		"Recharge_money": "مبلغ الشحن",
		"rechargeStatus": "حالة الشحن",
		"Unpaid": "غير مدفوع",
		"Paid": "مدفوع",
		"Recharge_successful": "نجح الشحن",
		"Recharge_fail": "فشل الشحن",
		"Recharging": "جاري الشحن",
		"normal": "عادي",
		"warning": "تحذير",
		"Overdue": "متأخر",
		"expired": "منتهي",
		"unknown": "غير معروف",
		"Recharge_status": "حالة الشحن",
		"ccid": "رقم بطاقة المجمع",
		"Traffic_status": "حالة البيانات",
		"Recharge": "شحن",
		"Recharge1": "شحن البيانات",
		"load": "عدد الأجهزة",
		"pn": "PN المجمع",
		"serial_number": "الرقم",
		"rechargeErr": "اختر مجمعات بنفس عدد الأجهزة",
		"rechargeDevice": "شحن الأجهزة:",
		"rechargePackage": "باقة الشحن:",
		"rechargeChannel": "طريقة الشحن:",
		"rechargePrice": "مبلغ الشحن:",
		"rechargeDiscount": "الخصم:",
		"scan": "امسح للدفع",
		"openWx": "افتح WeChat على هاتفك",
		"scanComplete": "امسح لإتمام الدفع",
		"previous": "رجوع",
		"rechargeSuc": "نجح الدفع",
		"rechargeSucInfo": "تم الدفع، البيانات تصل خلال 24 ساعة",
		"orderno": "رقم الطلب",
		"Recharged": "تم الشحن بنجاح",
		"Recharge_List": "قائمة الشحن",
		"not_for_the_time_being": "تأجيل",
		"Recharge_now": "اشحن الآن",
		"early_warning": "تحذير انتهاء البطاقة",
		"Content_warning": "البطاقة على وشك الانتهاء، اشحن لتفادي التعطيل!",
		"Recharge_reminder": "تذكير الشحن",
		"Recharge_Selected": "شحن",
		"Search": "بحث",
		"cancel": "إلغاء",
		"confirm": "تأكيد",
		"rechMoney": "الدفع",
		"rechDiscount": "الخصم",
		"rechScan": "امسح عبر WeChat للدفع",
		"rechTip": "نصيحة: 1) نفس نوع البطاقة (مثال: 4G محلي)، نفس حمل الأجهزة ونفس المنصة؛ 2) البطاقات منتهية الصلاحية أو الشحن من 25 إلى 5 قد يستغرق 1-14 يومًا",
		"Hint_language": "لديك أجهزة 2G. استبدلها بأجهزة 4G!",
		"Tips": "تلميح",
		"Confirm_recharge": "تأكيد الشحن",
		"Cancel_recharge": "إلغاء الشحن",
		"Hint_language1": "للمساعدة تواصل على 0755-89993588",
		"recharge_type": "النوع",
		"Service_Area": "منطقة الخدمة",
		"Package_type": "نوع الباقة",
		"domestic": "محلي",
		"abroad": "خارجي",
		"Recharge_tip": "تذكير الشحن",
		"Recharge_tip1": "الشحن الدفعي للبطاقات من نفس النوع فقط",
		"Recharge_tip2": "اختر بطاقات من نفس النوع والمنطقة",
		"Recharge_tip3": "يُنصح مستخدمو WeChat",
		"Recharge_tip4": "يُنصح مستخدمو PayPal",
		"Recharge_tip5": "الدفع عبر WeChat",
		"Recharge_tip6": "بطاقات غير مدعومة، تواصل مع المدير",
		"area_domestic": "الصين",
		"area_abroad": "دولي",
				"remedy_title": "علاج طلب الشحن",
				"upload_tip": "تذكير ودي: تنسيق ملف التحميل هو .txt"
	},
	"customize": {
		"switchSkin": "تبديل السمة",
		"classic": "وردي",
		"purple": "بنفسجي",
		"blue": "أزرق كلاسيكي",
		"orange": "برتقالي",
		"green": "أخضر ناعم"
	},
	"firmware": {
		"Firmware_limit_format": "صرف \".bin\"، \".hex\" اور \".s19\" فارمیٹ کی فائلیں اپ لوڈ کی جا سکتی ہیں",
		"Firmware_upload_fail": "اپ لوڈ ناکام رہا، براہ کرم دوبارہ اپ لوڈ کریں!",
		"Firmware_upload_failTip": "اپ لوڈ ناکام",
		"Firmware_limit1": "زیادہ سے زیادہ اپ لوڈ کیا جا سکتا ہے",
		"Firmware_limit2": "",
		"Firmware_limit3": "فرم ویئر",
		"Firmware_limitM": "ایک فرم ویئر کا سائز اس سے زیادہ نہیں ہو سکتا",
		"Firmware_Name": "اسم البرنامج",
		"Firmware_desrc": "وصف البرنامج",
		"Size": "الحجم (KB)",
		"Upload_Time": "وقت الرفع",
		"Operation": "تشغيل",
		"Firmware_List": "إدارة البرامج",
		"Firmware_Lists": "قائمة البرامج",
		"Add_Firmware": "إضافة برنامج",
		"deleteFirmware": "حذف",
		"Firmware_Version": "رقم الإصدار",
		"editFirmware": "تعديل",
		"downloadFirmware": "تنزيل",
		"tips": "تلميح",
		"noRecord": "لا يوجد سجل",
		"delete_firmware": "تأكيد حذف هذا البرنامج؟",
		"del_firmware": "حذف البرنامج",
		"firmware_upgrade": "ترقية البرنامج",
		"uploadTips": "ارفع ملف البرنامج",
		"cancel": "إلغاء",
		"confirm": "تأكيد",
		"Upload_firmware": "رفع البرنامج",
		"Firmware_description": "وصف البرنامج:",
		"enter_content": "أدخل المحتوى",
		"Select_file": "اختر الملف",
		"limit": "يمكن فقط رفع ملفات .bin و .hex، بحد أقصى 8 ميجابايت",
		"limit0": "فقط .bin و .hex و .s19، حتى 8M",
		"limit1": "فقط ملفات xlsx",
		"limit2": "تلميح: العمود A = PN، العمود B = الاسم",
		"limit3": "تمت الإضافة بنجاح",
		"error1": "فقط .bin و .hex و .s19",
        "error2": " Please press LFU button",
		"deleteSuc": "تم الحذف بنجاح",
		"UploadTitle": "ارفع ملفاً دفعياً",
		"Upload": "رفع البرنامج",
		"Upload1": "رفع ملف",
		"upgrade_quit1": "خطأ في الترقية، تم الخروج!",
		"upgrade_quit2": "فشلت الترقية، حاول لاحقاً!",
		"upgrade_quit3": "نجحت الترقية",
		"upgrade_quit4": "أُلغيت الترقية يدوياً",
		"upgrade_quit5": "ليس قيد الترقية",
		"upgrade_quit6": "إلغاء الترقية",
		"upgrade_quit7": "فشلت الترقية",
		"upgrade_quit8": "خطأ في الترقية",
		"upgrading": "جاري الترقية",
		"upgrading1": "جاري الاتصال للترقية، انتظر",
		"updateCompleted": "تمت الترقية",
		"CancelUpgradeSuc": "تم إلغاء الترقية بنجاح",
		"FailedCancelUpgrade": "فشل إلغاء الترقية",
		"CancelUpgradeSuc11": "تم الإلغاء، انتظر اتصال المجمع",
		"upgrade_wait": "جاري التحضير للترقية، انتظر 1-2 دقيقة",
		"upgrade_wait1": "اكتمل التحضير، انتظر اتصال المجمع",
		"colOffline": "المجمع غير متصل",
		"colUpgrading": "قيد الترقية بالفعل",
		"UpgradeStarting": "ترقية بدأة، يرجى الانتظار...",
		"upgradeSq_fail": "فشل تحديث datalogger، يرجى المحاولة مرة أخرى لاحقاً!",
	},
	"browse": {
		"usr": "حساب فرعي",
		"email": "البريد",
		"mobile": "الهاتف",
		"gts": "تاريخ التسجيل",
		"desc": "ملاحظة",
		"enableStatus": "حالة التفعيل",
		"Enable": "مفعّل",
		"Disable": "معطّل",
		"addBrowse": "إضافة حساب فرعي",
		"pleaseUsr": "أدخل الحساب الفرعي",
		"accountInfo": "معلومات الحساب",
		"username": "اسم المستخدم",
		"password": "كلمة المرور",
		"newPassword": "كلمة المرور الجديدة",
		"confirmPassword": "تأكيد كلمة المرور",
		"usrInfo": "معلومات المستخدم",
		"device": "اختر المشروع",
		"pleaseDevice": "اختر المشروع",
		"pleaseDevice_title": "اختر المشروع",
		"pleaseStatus": "اختر الحالة",
		"addSuccess": "تمت إضافة الحساب الفرعي بنجاح",
		"editSuccess": "تم تعديل الحساب الفرعي بنجاح",
		"editBrowse": "تعديل الحساب الفرعي",
		"deleteSuccess": "تم الحذف بنجاح",
		"deleteBrowse": "حذف",
		"delete_browse": "تأكيد حذف الحساب الفرعي؟",
		"please_browsepwd": "تحقق من كلمة المرور وتأكيدها"
	},
	"retrieve": {
		"Retrieve_password": "استعادة كلمة المرور",
		"Retrieve_passwordPhone": "استعادة عبر الهاتف",
		"Retrieve_passwordEmail": "استعادة عبر البريد",
		"passwordEmail": "البريد غير مرتبط",
		"passwordEmail1": "البريد غير متطابق",
		"passwordPhone": "الهاتف غير مرتبط",
		"passwordPhone1": "الهاتف غير متطابق",
		"login": "تسجيل الدخول",
		"signup": "تسجيل",
		"Enter_account": "أدخل الحساب",
		"Verify_identidy": "تحقق من الهوية",
		"reset_Password": "إعادة تعيين كلمة المرور",
		"finish": "إنهاء",
		"account_password": "أدخل الحساب لاستعادة كلمة المرور",
		"username": "اسم المستخدم",
		"Verification_code": "رمز التحقق",
		"phone_number": "رقم الهاتف",
		"new_password": "كلمة المرور الجديدة",
		"Con_password": "تأكيد كلمة المرور",
		"enter_name": "أدخل اسم المستخدم",
		"enter_code": "أدخل رمز التحقق",
		"Change_one": "غيّر الصورة",
		"confirm": "تأكيد",
		"bound_mobile": "أدخل الهاتف المرتبط",
		"Email_verification": "تحقق من البريد",
		"Obtain_code": "جلب الرمز",
		"code_1minute": "تم إرسال الرمز لهاتفك، صالح دقيقة واحدة.",
		"Email": "البريد",
		"bound_email": "أدخل البريد المرتبط",
		"Phone_verification": "تحقق من الهاتف",
		"code_5minutes": "تم إرسال الرمز لبريدك، صالح 5 دقائق.",
		"New_password": "كلمة المرور الجديدة",
		"Confirm_password": "تأكيد كلمة المرور",
		"Reset_successfully": "تمت إعادة التعيين، احفظ كلمة المرور",
		"re-register": "تسجيل الدخول مجدداً",
		"Incorrect_code": "رمز التحقق غير صحيح",
		"email_first": "أدخل البريد أولاً",
		"mobile_first": "أدخل الهاتف أولاً",
		"Reset_passwordSuc": "تمت إعادة تعيين كلمة المرور بنجاح",
		"Get_codeSucc": "تم جلب الرمز بنجاح",
		"Getting_progress": "جاري الجلب، انتظر!",
		"Newloginpassword": "كلمة المرور الجديدة",
		"Confirmloginpassword": "تأكيد كلمة المرور",
		"step1": "الخطوة 1",
		"step2": "الخطوة 2",
		"step3": "الخطوة 3",
		"step4": "الخطوة 4"
	},
	"errCode": {
		"0": "عادي، بدون أخطاء",
		"1": "فشل",
		"2": "انتهاء المهلة، النظام مشغول، حاول لاحقاً",
		"3": "خطأ في النظام، تواصل مع المدير",
		"4": "لا تدخل أحرف خاصة",
		"5": "خطأ في الملح",
		"6": "خطأ في تنسيق المعلمات",
		"7": "معلمات مفقودة",
		"8": "رفض المنصة",
		"9": "عملية غير مدعومة",
		"10": "لم يتم التحقق، سجل الدخول مجدداً",
		"11": "لا صلاحية للعملية",
		"12": "لا يوجد سجل",
		"13": "تجاوز الحد",
		"14": "عملية مكررة",
		"15": "لم يُعثر على مفتاح المصنّع",
		"16": "كلمة مرور خاطئة",
		"17": "خطأ في تنسيق كلمة المرور",
		"18": "الهاتف مرتبط، غيّره أو افك الربط",
		"19": "خطأ في تنسيق الهاتف",
		"20": "خطأ في تنسيق البريد",
		"21": "خطأ في تنسيق اسم المستخدم",
		"22": "خطأ في اسم الشركة",
		"23": "رمز المصنّع غير صالح",
		"24": "اسم المستخدم موجود",
		"25": "الحساب معطّل، تواصل مع المدير",
		"26": "البريد مرتبط، غيّره أو افك الربط",
		"27": "الحساب ملغى، تواصل مع المدير",
		"256": "لا توجد بيانات",
		"257": "لا يوجد مجمع",
		"258": "لا يوجد جهاز",
		"259": "PN غير صالح، تحقق منه",
		"260": "لا توجد محطة",
		"261": "لم يُعثر على المستخدم",
		"262": "الجهاز غير متصل",
		"263": "المجمع غير متصل",
		"264": "لا إنذارات للجهاز",
		"265": "لا جهاز مراقبة بيئية",
		"271": "لا تعديلات",
		"272": "ربط مكرر",
		"273": "لا يمكن إضافة مجمعات مصنّعين آخرين",
		"276": "لا يمكن نقل مالكين لديهم مجمعات مصنّعين آخرين",
		"288": "لا توجد كاميرا",
		"352": "لا يوجد برنامج ثابت",
		"353": "لا يوجد بروتوكول",
		"368": "لا يوجد دور",
		"369": "لا توجد مجموعة مستخدمين",
		"370": "لا توجد مجموعة محطات",
		"371": "لا توجد باقات شحن GPRS",
		"372": "لا توجد طلبات شحن GPRS",
		"384": "خطأ في رمز التحقق",
		"385": "لا يوجد device_token",
		"386": "لا توجد معلومات تهيئة",
		"387": "لا يوجد نوع مجمع",
		"512": "رمز التحقق SMS غير متطابق",
		"513": "انتهت صلاحية رمز SMS",
		"514": "الهاتف/البريد غير مرتبط",
		"515": "الهاتف/البريد غير متطابق",
		"516": "الاسم موجود",
		"517": "المستخدم أو المحطة لديه مجمعات",
		"518": "المستخدم لديه مستخدمون فرعيون",
		"519": "اسم المستخدم موجود",
		"520": "PN مكرر",
		"521": "المجمع لا يتبع هذا المستخدم",
		"522": "المجمع موجود",
		"523": "ليس حساب مشاهدة",
		"525": "الرمز مُرسل، حاول لاحقاً",
		"528": "الدور مرتبط بمستخدم، لا يمكن حذفه",
		"768": "البروتوكول لا يحتوي حقول اختيارية",
		"772": "المجمع مرتبط بالفعل",
		"1024": "لمالك المحطة فقط",
		"1025": "للمدير فقط",
		"1026": "لمصنّع الأجهزة فقط",
		"1027": "المستخدم الأعلى يجب أن يكون مديراً أو مصنّعاً",
		"1028": "طريقة شحن غير مدعومة",
		"1029": "رقم مجمع مكرر",
		"1030": "بطاقة GPRS غير صالحة",
		"1031": "المستخدم لم يُنشأه هذا المدير",
		"1041": "المفتاح غير صالح أو غير موجود",
		"1042": "CCID غير صالح",
		"1792": "المجمعات يجب أن تتبع هذا المدير"
	},
	"controlDeviceErrCode": {
		"1": "فشلت العملية، تحقق من الجهاز!",
		"2": "انتهاء المهلة، حاول مجدداً!",
		"3": "خطأ في النظام، تواصل مع المدير",
		"6": "خطأ في التنسيق، تواصل مع المدير",
		"8": "رفض، تواصل مع المدير",
		"9": "عملية غير مدعومة، تواصل مع المدير",
		"11": "لا صلاحية، تواصل مع المدير",
		"263": "المجمع غير متصل، حاول لاحقاً!"
	},
	"control":{
		setting: "إرسال",
		TouSetting: "ضبط وضع عمل النظام",
		touCharge: "الشحن أولاً",
		touPersonal: "استهلاك ذاتي",
		touComplete: "بيع كامل",
		touClipping: "إدارة الذروة والقاع",
		touOffgrid: "تطبيق خارج الشبكة",
		confirmModeSwitch: "تأكيد تبديل الوضع؟",
		modeSwitch: "تبديل الوضع",
		startTime: "وقت البدء",
		endTime: "وقت الانتهاء",
		paramValue: "اختر قيمة المعلمة",
		Monday: "الإثنين",
		Tuesday: "الثلاثاء",
		Wednesday: "الأربعاء",
		Thursday: "الخميس",
		Friday: "الجمعة",
		Saturday: "السبت",
		Sunday: "الأحد",
		syncSetDay: "مزامنة يومياً",
		time: "فترة 1",
		time1: "فترة 2",
		time2: "فترة 3",
		time3: "فترة 4",
		time4: "فترة 5",
		time5: "فترة 6",
		setFail: "فشل الإرسال",
		readFail: "فشلت القراءة",
		charge: "شحن",
		discharge: "تفريغ",
		reading: "نجحت القراءة",
		reading_loading: "جاري القراءة...",
		pvMode: "وضع الشبكة",
		"screenshot": "لقطة شاشة"
	},
	"CollectorCountByOMSOrder": {
		"1": "فشلت العملية",
		"7": "معلمات مفقودة",
		"8": "رفض، تواصل مع المدير",
		"12": "لا مجمعات صالحة في الطلب",
		"23": "رمز المصنّع غير صالح",
		"259": "مجمعات غير صالحة في الطلب",
		"261": "لم يُعثر على الموزع",
		"772": "مجمعات مرتبطة في الطلب"
	},
	"message": {
		"uname_is_required": "الحساب مطلوب",
		"id_is_required": "المجموعة مطلوبة",
		"pwd_is_required": "كلمة المرور مطلوبة",
		"confpwd_is_required": "تأكيد كلمة المرور مطلوب",
		"invitation_is_required": "رمز التجربة مطلوب",
		"pwdAgain": "أعد إدخال كلمة المرور",
		"pwdSame": "كلمة المرور الجديدة والقديمة متطابقتان",
		"oldPass_wrong": "كلمة المرور القديمة خاطئة",
		"pwdNotsame": "كلمتا المرور غير متطابقتين",
		"email_is_required": "البريد مطلوب",
		"email_info": "بريد صحيح حتى 64 حرف",
		"mobile_is_required": "الهاتف مطلوب",
		"pn_is_required": "PN مطلوب",
		"PN_info": "PN طوله 14 أو 18، حرف كبير أول",
		"nodata": "لا توجد بيانات",
		"length2_64": "الطول 2 إلى 64 حرف",
		"length2_32": "الطول 2 إلى 32 حرف",
		"length6_20": "6-20 حرف، رقم، شرطة",
		"length6_32": "الطول 6 إلى 32 حرف",
		"delete_plant": "حذف المحطة",
		"modify_plant": "تعديل المحطة",
		"Exporting_the_report": "تصدير التقرير",
		"cancel": "إلغاء",
		"search": "بحث",
		"Logging_off": "الحساب قيد الإلغاء، لا يمكن الدخول",
		"country_is_required": "اختر البلد أو المنطقة"
	},
	"report": {
		"Export_report": "تصدير التقرير",
		"Subscribe_report": "اشتراك التقرير",
		"all_reports": "تصدير الكل",
		"Report_type": "نوع التقرير:",
		"Daily_report": "تقرير يومي",
		"Monthly_report": "تقرير شهري",
		"Yearly_Report": "تقرير سنوي",
		"Total_report": "تقرير إجمالي",
		"customize": "مخصص",
		"Report_date": "تاريخ التقرير:",
		"Report_date1": "ملاحظة: النطاق حتى 31 يوماً",
		"select_date": "اختر التاريخ",
		"to": "إلى",
		"start_date": "تاريخ البدء",
		"End_date": "تاريخ الانتهاء",
		"cancel": "إلغاء",
		"Export": "تصدير",
		"download": "جاري التنزيل، انتظر",
		"Batch_export": "تصدير دفعي",
		"current": "الآن",
		"no_deAlarm": "لا إنذارات في الشهر الماضي",
		"Export_alarm": "تصدير الإنذارات"
	},
	"actionLog": {
		"index": "الرقم",
		"date": "التاريخ",
		"user": "المستخدم",
		"acitonDesc": "وصف الإجراء",
		"startTime": "وقت البدء",
		"endTime": "وقت الانتهاء",
		"userNote": "أدخل اسم المستخدم",
		"userName": "اسم المستخدم",
		"uidNote": "أدخل UID",
		"PNNote": "أدخل PN",
		"actionNote": "أدخل اسم العملية",
		"All": "الكل"
	},
	"factory": {
		"name": "اسم المصنّع",
		"code": "رمز المصنّع",
		"time": "وقت الإنشاء",
		"append": "إضافة رمز مصنّع",
		"amend": "تعديل رمز مصنّع",
		"delete": "حذف رمز مصنّع",
		"delete_warn": "تأكيد حذف رمز المصنّع؟",
		"input_tip": "الرمز 2-3 أحرف أو أرقام",
		"error_tip": "خطأ في الإدخال",
		"right_tip": "الإدخال صحيح",
		"editSuc": "تم التعديل",
		"prompt_codeTip": "رمز المصنّع مطلوب",
		"prompt_nameTip": "اسم المصنّع مطلوب",
		"ID": "معرف المصنّع",
		"acount": "حساب المصنّع",
		"usrName": "اسم الحساب",
		"acountType": "نوع الحساب",
		"isEnabled": "مفعّل",
		"chooseIsEnabled": "اختر التفعيل",
		"enabled": "مفعّل",
		"disabled": "معطّل",
		"visibleDevcode": "رموز الأجهزة المرئية",
		"pwd": "كلمة المرور",
		"accountInfo": "معلومات الحساب",
		"comfirmPwd": "تأكيد كلمة المرور",
		"factoryInfo": "معلومات المصنّع",
		"devcode": "رمز الجهاز",
		"devcode_is_requeired": "رمز الجهاز مطلوب",
		"confirmDelete": "تأكيد الحذف",
		"confirmDelete1": "المصنّع؟",
		"ecoin": "عملة E"
	},
	"keyList": {
		"companyName": "اسم الشركة الكامل",
		"version_number": "رقم الإصدار",
		"client": "العميل",
		"domainName": "اسم النطاق الكامل",
		"contact_information": "معلومات الاتصال",
		"key": "المفتاح",
		"describe": "الوصف",
		"unseal": "مفعّل",
		"platform": "المنصة",
		"companyNameTips": "اسم الشركة مطلوب",
		"domainNameTips": "اسم النطاق مطلوب",
		"version_numberTips": "رقم الإصدار مطلوب",
		"contact_informationTips": "معلومات الاتصال مطلوبة",
		"clientTips": "المنصة مطلوبة",
		"keyTips": "المفتاح مطلوب",
		"keyTips2": "مفتاح بطول 16 بايت",
		"describeTips": "الوصف مطلوب",
		"unsealTips": "التفعيل مطلوب"
	},
	"protocol": {
		"pn": "رقم PN",
		"postal_address": "عنوان الاتصال",
		"Protocol_encoding": "رمز البروتوكول",
		"date": "التاريخ",
		"Please_date": "اختر التاريخ",
		"Protocol_instructions": "تعليمات البروتوكول",
		"Query_Results": "نتائج الاستعلام",
		"query": "استعلام",
		"CRC_verification": "تحقق CRC",
		"Length_verification": "تحقق الطول",
		"Data_index": "فهرس البيانات",
		"raw_data": "البيانات الخام",
		"verification_results": "نتيجة تحقق CRC",
		"agreement": "متطابق",
		"atypism": "غير متطابق",
		"verification_result": "نتيجة تحقق الطول",
		"Analysis_results": "نتائج التحليل",
		"Please_results": "اجلب نتائج الاستعلام أولاً"
	},
	"rawData": {
		"pn": "رقم PN",
		"Equipment_number": "الرقم التسلسلي",
		"Equipment_coding": "رمز الجهاز",
		"Device_address": "عنوان الجهاز",
		"date": "التاريخ",
		"Please_date": "اختر التاريخ",
		"encrypted": "مشفّر",
		"Please_type": "اختر نوع التشفير",
		"yes": "نعم",
		"no": "لا",
		"raw_data": "البيانات الخام",
		"analysis": "تحليل"
	},
	"collectionFrequencyUP": {
		"collect_fast": "تسريع معلمات التدفق",
		"collect_fast2":" توانائی کے بہاؤ کو تیز کرنا",
		"collect_fast_fail":"فشل التسريع، حاول مرة أخرى",
		"collect_fasting": "جاري تسريع معلمات التدفق",
		"collect_fast_starting": "جاري بدء التسريع",
		"collect_fast1": "تسريع تفاصيل البيانات",
		"collect_fast1ing": "جاري تسريع تفاصيل البيانات",
		"paySecCon": "تأكيد الدفع",
		"energyFetchPic": "تأكيد الشحن للتسريع كما في الصورة",
		"historyFetchPic": "تأكيد الشحن للتسريع كما في الصورة",
		"reRechargeTip1": "تم شراء خدمة تسريع تدفق الطاقة للجهاز الحالي بالفعل. سيؤدي الاستمرار في الشراء إلى تحمل رسوم مرة أخرى، هل تريد المتابعة؟",
		"reRechargeTip": "تم شراء خدمة تسريع تفاصيل البيانات للجهاز الحالي بالفعل. سيؤدي الاستمرار في الشراء إلى تحمل رسوم مرة أخرى، هل تريد المتابعة؟",
		"continueRecharge": "متابعة الشحن",
		"collect_fasting_title": "المعلمات الآنية لا تُخزن",
		"collect_Order_Record": "سجل شحن التسريع",
		"collect_recharge": "شحن تسريع الجمع (تفاصيل البيانات)",
		"collect_recharge1": "شحن تسريع الجمع (تدفق الطاقة)",
		"Package": "باقة التسريع",
		"every_interval": "المواصفات المختارة: كل فترة",
		"gather": "جمع",
		"Once": "مرة",
		"Payment_method": "طريقة الدفع",
		"Online_payment": "دفع إلكتروني",
		"Recharge_now": "اشحن الآن",
		"have_read": "قرأت بعناية",
		"Collection_terms": "شروط شحن التسريع",
		"Purchase_Terms": "شروط الشراء",
		"Purchase_Terms1": "فترة صلاحية تسريع الجمع",
		"Purchase_Terms2": "سيتم حساب وقت انتهاء خدمة تسريع الجمع تلقائيًا بناءً على مدة الباقة التي اشتريتها. يخضع وقت الانتهاء المحدد لما يتم عرضه على الصفحة",
		"Purchase_Terms3": "هل يمكن تسريع بعض المعلمات فقط؟",
		"Purchase_Terms4": "الإصدار الحالي يسري على جميع المعلمات",
		"Purchase_Terms5": "سعر الباقة",
		"Purchase_Terms6": "السعر يُحسب حسب عدد المعلمات ومعدل الجمع",
		"Purchase_Terms7": "أسئلة أخرى",
		"Purchase_Terms8": "تواصل مع خدمة العملاء",
		"Collect_terms": "شروط شحن التسريع",
		"Collect_terms1": "شروط خدمة تسريع معدل الجمع",
		"Collect_terms2": "أولاً: نطاق الباقة",
		"Collect_terms3": "يسري على معلمات العرض في بروتوكول المجمع",
		"Collect_terms4": "ثانياً: تغيير البروتوكول/الجهاز",
		"Collect_terms5": "التغيير لا يشمله التسريع",
		"Collect_terms6": "ثالثاً: إلغاء الباقة",
		"Collect_terms7": "الدفع غير قابل للإلغاء أو التغيير",
		"Collect_terms8": "رابعاً: سعر الباقة",
		"Collect_terms9": "السعر يُحسب حسب عدد المعلمات ومعدل الجمع",
		"Collect_terms10": "خامساً: استهلاك البيانات",
		"Collect_terms11": "التسريع يزيد من استهلاك البيانات",
		"Scan_payment": "امسح للدفع",
		"Recharge_result": "نتيجة الشحن",
		"Recharge_successful": "نجح الشحن",
		"Recharge_successful_next": "مبروك! سيتم ترقية معدل الجمع",
		"Order_No": "رقم الطلب",
		"Recharge_time": "وقت الشحن",
		"Recharge_amount": "مبلغ الشحن",
		"view_order": "عرض الطلب",
		"Recharge_failed": "فشل الشحن",
		"Recharge_failed_next": "نأسو! حاول الدفع مجدداً",
		"PN_order": "PN/رقم الطلب",
		"View_Details": "عرض التفاصيل",
		"Type": "نوع الشحن",
		"Real_parameters": "معلمات آنية",
		"History_Data": "بيانات تاريخية",
		"acquisition_frequency": "معدل الجمع",
		"device_Info": "معلومات الجهاز",
		"noRecharg": "المجمع لا يدعم الشحن",
		"noRecharg_min": "الجمع بأسرع معدل!",
		"noRecharg_wifi": "الإصدار الحالي لمجمعات Wi-Fi فقط",
		"paypalTip": "المبلغ النهائي حسب PayPal",
		"upPrice": "فرق السعر"
	},
	alarmNew:{
		"fileName":"اسم الملف",
		"fileSize":"حجم الملف",
		"fileStatus":"حالة الملف",
		"progress":"التقدم",
		"can":"قابل للتنزيل",
		"no":"جاري التصدير",
		"history":"سجل التصدير",
		"brand3-list":"قائمة الوحدات المتكاملة"
	},
	shuoriExport:{
		"exportRecords": "سجل التصدير",
		"export": "تصدير",
		"exportTask": "تم إنشاء المهمة، نزّل لاحقاً",
		"noDownload": "عنوان غير صالح، حاول مجدداً",
		"data": "التاريخ"
	},
	colUnBindRecord: {
		"UnBindRecord": "سجل فك ربط المجمع",
		"unStatus": "حالة فك الربط",
		"unScene": "سيناريو فك الربط",
		"oldUser": "المستخدم القديم",
		"newUser": "المستخدم الجديد",
		"unCount": "عدد مرات فك الربط",
		"pnBarCode": "الباركود",
		"devicePicture": "صورة الجهاز",
		"ip": "IP فك الربط",
		"unTime": "وقت فك الربط"
	},
	rosRecharge: {
		'electronicInvoicing': 'الفوترة الإلكترونية',
		'issueEInvoice': 'إصدار فاتورة إلكترونية',
		'invoiceHistory': 'سجل الفواتير',
		'rechargeDuration': 'مدة إعادة الشحن',
		'year': 'سنة',
		'month': 'شهر',
		'day': 'يوم',
		'days': 'أيام',
		'pendingPayment': 'بانتظار الدفع',
		'paymentSuccess': 'تم الدفع بنجاح',
		'paymentFailed': 'فشل الدفع',
		'orderClosed': 'تم إغلاق الطلب',
		'serviceTerminated': 'تم إنهاء الخدمة',
		'unpaid': 'غير مدفوع',
		'paying': 'جاري الدفع',
		'paid': 'تم الدفع',
		'refunded': 'تم الاسترداد',
		'cancelled': 'ملغي',
		'rechargeSuccess': 'تمت إعادة الشحن بنجاح',
		'rechargeFailed': 'فشلت إعادة الشحن',
		'pleaseSelectDate': 'يرجى تحديد التاريخ',
		'orderNo': 'رقم الطلب',
		'batchInvoicing': 'إصدار فواتير دفعي',
		'rechargeType': 'نوع إعادة الشحن',
		'trafficRecharge': 'شحن البيانات',
		'collectRecharge': 'شحن الجمع',
		'rechargeStatus': 'حالة إعادة الشحن',
		'invoice': 'فاتورة',
		'invoiceStatus': 'حالة الفاتورة',
		'invoiceTime': 'وقت إصدار الفاتورة',
		'viewDetail': 'عرض التفاصيل',
		'invoicing': 'جاري إصدار الفاتورة',
		'invoiceSuccess': 'تم إصدار الفاتورة',
		'invoiceFailed': 'فشل إصدار الفاتورة',
		'issueElectronicInvoice': 'إصدار فاتورة إلكترونية',
		'invoiceType': 'نوع الفاتورة',
		'generalInvoice': 'فاتورة عادية',
		'specialInvoice': 'فاتورة خاصة',
		'headerType': 'نوع العنوان',
		'companyHeader': 'عنوان الشركة',
		'personalHeader': 'عنوان شخصي/غير مؤسسة',
		'pleaseInputCompanyHeader': 'يرجى إدخال عنوان الشركة',
		'taxNumber': 'رقم ضريبة الشركة',
		'pleaseInputTaxNumber': 'يرجى إدخال رقم تعريف دافع الضرائب',
		'headerName': 'اسم العنوان',
		'suggestPersonalName': 'يُنصح بإدخال الاسم الشخصي/اسم المتجر',
		'invoiceContent': 'محتوى الفاتورة',
		'internetCommService': 'خدمات الاتصالات عبر الإنترنت',
		'invoiceAmount': 'مبلغ الفاتورة',
		'yuan': 'يوان',
		'moreInfo': 'مزيد من المعلومات',
		'remarkAddressEtc': 'ملاحظات، عنوان، إلخ',
		'companyAddress': 'عنوان الشركة',
		'pleaseInputCompanyAddress': 'يرجى إدخال عنوان الشركة',
		'companyPhone': 'هاتف الشركة',
		'pleaseInputCompanyPhone': 'يرجى إدخال هاتف الشركة',
		'openingBank': 'بنك فتح الحساب',
		'pleaseInputOpeningBank': 'يرجى إدخال اسم البنك',
		'bankAccount': 'رقم الحساب البنكي',
		'pleaseInputBankAccount': 'يرجى إدخال رقم الحساب البنكي',
		'remark': 'ملاحظة',
		'pleaseInputRemark': 'يرجى إدخال الملاحظة',
		'email': 'البريد الإلكتروني',
		'pleaseInputEmail': 'يرجى إدخال عنوان البريد الإلكتروني',
		'cancel': 'إلغاء',
		'submit': 'إرسال',
		'invoiceResult': 'نتيجة إصدار الفاتورة',
		'invoiceSubmitted': 'تم تقديم طلب إصدار الفاتورة',
		'invoiceExpectedTip': 'سيتم إصدار الفاتورة خلال 48 ساعة، يرجى مراجعة بريدك',
		'viewInvoiceStatus': 'عرض حالة الفاتورة',
		'pleaseInputHeaderName': 'يرجى إدخال اسم العنوان',
		'pleaseInputValidEmail': 'يرجى إدخال عنوان بريد إلكتروني صحيح',
		'invoiceApplyFailed': 'فشل طلب إصدار الفاتورة',
		'viewInvoice': 'عرض الفاتورة',
		'downloadPdf': 'تحميل ملف PDF',
		'manualService': 'خدمة العملاء',
		'invoiceSentToEmail': 'تم إرسال معلومات الفاتورة إلى بريدك، يرجى المراجعة',
		'pleaseWaitInvoicing': 'يرجى الانتظار حتى اكتمال إصدار الفاتورة',
		'pleaseContactManual': 'يرجى التواصل مع خدمة العملاء لإصدار الفاتورة',
		'noPdfAvailable': 'لا توجد ملفات PDF للتحميل',
		'serviceUnavailable': 'خدمة العملاء غير متاحة حالياً',

	}
}
export default sa;